import * as THREE from 'three'

// 🎯 MAPA EXTRA OFFSETÓW DLA ROTACJI SECTIONS, GATE, DOOR
const SECTION_ROTATION_OFFSETS: Record<string, Record<number, number>> = {
  // 🚪 Gate/Door: są takie same dla wszystkich konfiguracji
  'gate': {
    1: -0.150,  // Jak door 1x
    2: -0.300,  // Jak door 2x
    3: -0.450,  // Jak door 3x
    4: -0.600,  // Jak door 4x
    5: -0.750   // Jak door 5x
  },
  'door': {
    1: -0.150,  // Zmniejsz dla 1x
    2: -0.300,  // Dostrój dla 2x
    3: -0.450,  // Dostrój dla 3x
    4: -0.600,
    5: -0.750
  },
  'vision-bet-long': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'slim-3d': {
    2: -0.300,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'royal_p50_5': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'lupane-muro': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'gladkie_medium': {
    2: -0.316,
    3: -0.474,
    4: -0.632,
    5: -0.790
  },
  'vision-bet-medium': {
    2: -0.316,
    3: -0.474,
    4: -0.632,
    5: -0.790
  },
  'slim': {
    2: -0.238,
    3: -0.357,
    4: -0.476,
    5: -0.596
  },
  'gladkie_max': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'slim3d-kopia': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'vision-bet-max': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'gladkie_long': {
    2: -0.396,
    3: -0.594,
    4: -0.792,
    5: -0.990
  },
  'lupane-muro-p22': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.148,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.222,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.296,   // Dla 4x: -baseWidth * 2
    5: -0.370    // Dla 5x: -baseWidth * 2.5
  },
  'lupane-muro-p38': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.148,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.222,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.296,   // Dla 4x: -baseWidth * 2
    5: -0.370    // Dla 5x: -baseWidth * 2.5
  },
  'lupane-muro-s22': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.148,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.222,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.296,   // Dla 4x: -baseWidth * 2
    5: -0.370    // Dla 5x: -baseWidth * 2.5
  },
  'royal_s50': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.198,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.297,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.396,   // Dla 4x: -baseWidth * 2
    5: -0.495    // Dla 5x: -baseWidth * 2.5
  },
  'royal_p50': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.198,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.297,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.396,   // Dla 4x: -baseWidth * 2
    5: -0.495    // Dla 5x: -baseWidth * 2.5
  },
  'lupane-muro-s38': {
    1: 0.0,      // Dla 1x: leftEdgeOffset.x już jest -baseWidth/2, więc 0 (bez dodatkowego offsetu)
    2: -0.148,   // Dla 2x: -baseWidth (przesuń do lewej krawędzi pierwszego bloku)
    3: -0.222,   // Dla 3x: -baseWidth * 1.5 (dostosowane do blockCenterOffset i rightOffset)
    4: -0.296,   // Dla 4x: -baseWidth * 2
    5: -0.370    // Dla 5x: -baseWidth * 2.5
  }
}

export class RotationManager {
  updateElementRotation(
    elementGroup: THREE.Group,
    newRotation: number,
    elements3D: Map<string, THREE.Group>
  ): void {
    const elementId = elementGroup.userData.fenceElementId
    if (!elementId) return

    // 🔑 BLOKADA: Nie aktualizuj pozycji elementu zamykającego!
    if (elementGroup.userData?.isClosingSection) {
      console.log('🚫 updateElementRotation: Element zamykający - pomijam aktualizację pozycji!')
      // Tylko zaktualizuj rotację wizualną i userData, ale NIE przesuwaj pozycji
      const inheritedRotation = elementGroup.userData?.inheritedRotation || 0
      const absoluteRotation = inheritedRotation - newRotation
      const absoluteRotationRad = (absoluteRotation * Math.PI) / 180
      
      elementGroup.rotation.y = absoluteRotationRad
      elementGroup.userData.rotation = newRotation
      elementGroup.userData.absoluteRotation = absoluteRotation
      elementGroup.userData.reactRotation = newRotation
      
      return
    }

    console.log('🔄🔄🔄 ========== UPDATE ELEMENT ROTATION ==========')
    console.log('Element:', elementId)
    console.log('Nowa rotacja (suwak):', newRotation)
    console.log('Position PRZED:', 'X:', elementGroup.position.x.toFixed(6), 'Z:', elementGroup.position.z.toFixed(6))

    // 🎯 INICJALIZUJ geometryOffsetZ jeśli nie istnieje (przy pierwszej rotacji)
    if (elementGroup.userData.geometryOffsetZ === undefined) {
      console.log('⚠️ geometryOffsetZ nie istnieje - inicjalizuję...')
      this.initializeGeometryOffset(elementGroup)
    } else {
      console.log('✅ geometryOffsetZ już istnieje:', elementGroup.userData.geometryOffsetZ)
    }

    if (elementGroup.name === 'post_group' || elementGroup.name === 'section_group') {
      newRotation = Math.max(-90, Math.min(90, newRotation))
    }

    // 🎯 Dla Slim 3D: oblicz pivot point PRZED zmianą rotacji
    const fenceConfig = elementGroup.userData?.fenceConfig
    console.log('🔍 DEBUG updateElementRotation:')
    console.log('  - elementGroup.name:', elementGroup.name)
    console.log('  - fenceConfig:', fenceConfig)
    console.log('  - fenceConfig?.id:', fenceConfig?.id)
    console.log('  - userData:', elementGroup.userData)
    
    const currentPos = elementGroup.position.clone()
    const currentAbsoluteRotation = elementGroup.userData?.absoluteRotation || 0
    const currentAbsoluteRotationRad = (currentAbsoluteRotation * Math.PI) / 180
    
    // 🎯 ZAWSZE używaj calculatePivotPoint – także dla Slim 3D section/gate/door/post
    // Ta funkcja zawiera całą specjalną logikę dla Slim 3D, Vision-Bet, Gladkie itd.
    const pivotPoint: THREE.Vector3 = this.calculatePivotPoint(elementGroup, elements3D)
    
    const inheritedRotation = elementGroup.userData?.inheritedRotation || 0
    const absoluteRotation = inheritedRotation - newRotation
    const absoluteRotationRad = (absoluteRotation * Math.PI) / 180

    console.log('inheritedRotation:', inheritedRotation)
    console.log('absoluteRotation:', absoluteRotation)
    console.log('pivotPoint:', 'X:', pivotPoint.x.toFixed(6), 'Z:', pivotPoint.z.toFixed(6))
    
    console.log('currentAbsoluteRotation:', currentAbsoluteRotation)
    
    // Standardowa logika dla WSZYSTKICH ogrodzeń (w tym Slim 3D)
    const vectorFromPivot = new THREE.Vector3(
      currentPos.x - pivotPoint.x,
      currentPos.y - pivotPoint.y,
      currentPos.z - pivotPoint.z
    )
    
    console.log('vectorFromPivot PRZED rotacją:', 'X:', vectorFromPivot.x.toFixed(6), 'Z:', vectorFromPivot.z.toFixed(6))
    
    const deltaRotation = absoluteRotation - currentAbsoluteRotation
    const deltaRotationRad = (deltaRotation * Math.PI) / 180
    
    console.log('deltaRotation:', deltaRotation)
    
    const rotationMatrix = new THREE.Matrix4()
    rotationMatrix.makeRotationY(deltaRotationRad)
    vectorFromPivot.applyMatrix4(rotationMatrix)
    
    console.log('vectorFromPivot PO rotacji:', 'X:', vectorFromPivot.x.toFixed(6), 'Z:', vectorFromPivot.z.toFixed(6))
    
    const newPos = pivotPoint.clone().add(vectorFromPivot)
    
    console.log('newPos:', 'X:', newPos.x.toFixed(6), 'Z:', newPos.z.toFixed(6))
    console.log('Position PO:', 'X:', newPos.x.toFixed(6), 'Z:', newPos.z.toFixed(6))
    
    elementGroup.position.copy(newPos)
    elementGroup.rotation.y = absoluteRotationRad

    elementGroup.userData.rotation = newRotation
    elementGroup.userData.absoluteRotation = absoluteRotation
    elementGroup.userData.reactRotation = newRotation
    
    // 🎯 OBLICZ PRAWĄ KRAWĘDŹ od ŚRODKA elementu
    const width = elementGroup.userData?.width || 2.0
    const newPosAfterRotation = elementGroup.position.clone()
    
    // Offset prawej krawędzi w lokalnych współrzędnych (bez geometryOffsetZ!)
    let rightEdgeOffset = new THREE.Vector3(width / 2, 0, 0)
    
    // 🎯 DODAJ TĘ SAMĄ LOGIKĘ REDUKCJI CO W elementManager.ts
    // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long, slim-3d i slim gate/door: traktuj jak section
    // Używamy już istniejącego fenceConfig z linii 151
    const elementType = elementGroup.userData?.elementType
    const isVisionBetLong = fenceConfig?.id === 'vision-bet-long'
    const isVisionBetMax = fenceConfig?.id === 'vision-bet-max'
    const isVisionBetMedium = fenceConfig?.id === 'vision-bet-medium'
    const isGladkieMedium = fenceConfig?.id === 'gladkie_medium'
    const isGladkieMax = fenceConfig?.id === 'gladkie_max'
    const isGladkieLong = fenceConfig?.id === 'gladkie_long'
    const isSlim3d = fenceConfig?.id === 'slim-3d'
    const isSlim = fenceConfig?.id === 'slim'
    const isRoyalS50 = fenceConfig?.id === 'royal_s50'
    const isRoyalP50 = fenceConfig?.id === 'royal_p50'
    const isMuroP22 = fenceConfig?.id === 'lupane-muro-p22'
    const isMuroS22 = fenceConfig?.id === 'lupane-muro-s22'
    const isMuroP38 = fenceConfig?.id === 'lupane-muro-p38'
    const isMuroS38 = fenceConfig?.id === 'lupane-muro-s38'
    const isVisionBetLongGateDoor = isVisionBetLong && (elementType === 'gate' || elementType === 'door')
    const isVisionBetMaxGateDoor = isVisionBetMax && (elementType === 'gate' || elementType === 'door')
    const isVisionBetMediumGateDoor = isVisionBetMedium && (elementType === 'gate' || elementType === 'door')
    const isGladkieMediumGateDoor = isGladkieMedium && (elementType === 'gate' || elementType === 'door')
    const isGladkieMaxGateDoor = isGladkieMax && (elementType === 'gate' || elementType === 'door')
    const isGladkieLongGateDoor = isGladkieLong && (elementType === 'gate' || elementType === 'door')
    const isSlim3dGateDoor = isSlim3d && (elementType === 'gate' || elementType === 'door')
    const isSlimGateDoor = isSlim && (elementType === 'gate' || elementType === 'door')
    const isRoyalS50GateDoor = isRoyalS50 && (elementType === 'gate' || elementType === 'door')
    const isRoyalP50GateDoor = isRoyalP50 && (elementType === 'gate' || elementType === 'door')
    const isMuroP22GateDoor = isMuroP22 && (elementType === 'gate' || elementType === 'door')
    const isMuroS22GateDoor = isMuroS22 && (elementType === 'gate' || elementType === 'door')
    const isMuroP38GateDoor = isMuroP38 && (elementType === 'gate' || elementType === 'door')
    const isMuroS38GateDoor = isMuroS38 && (elementType === 'gate' || elementType === 'door')
    const isVisionBetGateDoor = isVisionBetLongGateDoor || isVisionBetMaxGateDoor || isVisionBetMediumGateDoor || isGladkieMediumGateDoor || isGladkieMaxGateDoor || isGladkieLongGateDoor || isSlim3dGateDoor || isSlimGateDoor || isRoyalS50GateDoor || isRoyalP50GateDoor || isMuroP22GateDoor || isMuroS22GateDoor || isMuroP38GateDoor || isMuroS38GateDoor
    const isSection = elementGroup.name === 'section_group' || isVisionBetGateDoor
    
    if (isSection) {
      const widthMultiplier = elementGroup.userData?.widthMultiplier || 1
      // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long i slim-3d gate/door: używaj konfiguracji section (ta sama konfiguracja dla wszystkich)
      const elementConfig = fenceConfig?.elements?.section
      
      let fenceType = ''
      if (isVisionBetGateDoor) {
        if (isVisionBetLong) fenceType = 'Vision-Bet-Long'
        else if (isVisionBetMax) fenceType = 'Vision-Bet-Max'
        else if (isVisionBetMedium) fenceType = 'Vision-Bet-Medium'
        else if (isGladkieMedium) fenceType = 'Gladkie-Medium'
        else if (isGladkieMax) fenceType = 'Gladkie-Max'
        else if (isGladkieLong) fenceType = 'Gladkie-Long'
        else if (isSlim3d) fenceType = 'Slim-3D'
        else if (isSlim) fenceType = 'Slim'
        else if (isRoyalS50) fenceType = 'Royal-S50'
        else if (isRoyalP50) fenceType = 'Royal-P50'
        else if (isMuroP22) fenceType = 'Muro-P22'
        else if (isMuroS22) fenceType = 'Muro-S22'
        else if (isMuroP38) fenceType = 'Muro-P38'
      }
      console.log(`🧪 TEST: ${isVisionBetGateDoor ? `${fenceType} ${elementType}` : 'Sekcja'} ${elementGroup.userData?.fenceElementId}, widthMultiplier=${widthMultiplier}`)
      
      // 🎯 Dla Muro P22/P38 section i gate/door: użyj specjalnej logiki dla rightEdge (takiej samej jak w elementManager.ts)
      // Gate/door w P22/P38 jest traktowane identycznie jak section
      if ((isMuroP22 || isMuroP38) && elementConfig) {
        // Dla widthMultiplier >= 2 odejmij część spacing od rightEdge
        if (widthMultiplier >= 2) {
          const spacing = elementConfig.spacing || 0.074
          // Różne kompensacje dla różnych widthMultiplier
          let reduction = 0
          if (widthMultiplier === 2) {
            reduction = spacing * -1.0 // -0.074 dla 2x (dodaje zamiast odejmować)
          } else if (widthMultiplier === 3) {
            reduction = spacing * 0.0 // 0.0 dla 3x
          } else if (widthMultiplier === 4) {
            reduction = spacing * 1.0 // 0.074 dla 4x
          } else if (widthMultiplier === 5) {
            reduction = spacing * 2.0 // 0.148 dla 5x
          }
          rightEdgeOffset.x -= reduction
          const fenceType = isMuroP22 ? 'P22' : 'P38'
          console.log(`🎯 Muro ${fenceType} ${elementType} ${widthMultiplier}x: odjęto ${reduction.toFixed(3)}m od rightEdge`)
        }
        // NIE odejmuj spacing i rightOffsetReduction dla P22/P38 section i gate/door (używamy tylko reduction)
      } else if (elementConfig) {
        // Standardowa logika dla innych ogrodzeń
        // Odejmij spacing (jak w elementManager.ts)
        rightEdgeOffset.x -= (elementConfig.spacing || 0)
        
        // Odejmij rightOffsetReduction (jak w elementManager.ts)
        const rightOffset = this.getRightOffsetForWidthMultiplier(elementConfig, widthMultiplier)
        const coefficient = this.getCoefficientForWidthMultiplier(elementConfig, widthMultiplier)
        const rightOffsetReduction = rightOffset * coefficient
        
        rightEdgeOffset.x -= rightOffsetReduction
      }
      
    }
    
    rightEdgeOffset.applyEuler(new THREE.Euler(0, absoluteRotationRad, 0))
    
    // 🎯 KLUCZOWE: Dla zrotowanych sekcji i postów w Muro Mix P22/P38, oblicz rightEdge z pivotPoint zamiast z newPosAfterRotation
    // To zapobiega kumulatywnym błędom w osi Z, ponieważ pivotPoint jest obliczany bezpośrednio z pozycji, a nie z rotacji
    const isMuroMix = elementGroup.userData?.originalFenceConfigId === 'lupane-muro-mix'
    const isMuroMixP22P38 = isMuroMix && (isMuroP22 || isMuroP38)
    const isMuroMixP22P38Section = isMuroMixP22P38 && isSection
    const isMuroMixP22P38Post = isMuroMixP22P38 && elementGroup.name === 'post_group'
    const isRotated = Math.abs(absoluteRotation) > 0.01
    
    // 🎯 Użyj newPosAfterRotation (który jest klonem elementGroup.position po ustawieniu na newPos)
    // newPosAfterRotation powinien być identyczny z newPos, ale używamy go, żeby być spójnym z resztą kodu
    const actualRightEdge = newPosAfterRotation.clone().add(rightEdgeOffset)
    
    elementGroup.userData.rightEdge = actualRightEdge.clone()
    
    console.log('💾 rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
    console.log('💾 Zapisano rightEdge:', 'X:', actualRightEdge.x.toFixed(6), 'Z:', actualRightEdge.z.toFixed(6))
    console.log('🔄🔄🔄 ============================================')

    window.dispatchEvent(
      new CustomEvent('elementRotationChanged', {
        detail: { elementId, rotation: newRotation }
      })
    )
  }

  /**
   * Pobiera rightOffset dla danego widthMultiplier z konfiguracji
   */
  private getRightOffsetForWidthMultiplier(elementConfig: any, widthMultiplier: number): number {
    // Sprawdź czy rightOffset jest obiektem z różnymi wartościami dla widthMultiplier
    if (elementConfig.rightOffset && typeof elementConfig.rightOffset === 'object') {
      const widthMultiplierKey = widthMultiplier.toString()
      return elementConfig.rightOffset[widthMultiplierKey] || elementConfig.rightOffset['1'] || 0.198
    }
    
    // Jeśli rightOffset jest liczbą, użyj jej dla wszystkich widthMultiplier
    if (typeof elementConfig.rightOffset === 'number') {
      return elementConfig.rightOffset
    }
    
    // Domyślna wartość
    return 0.198
  }

  /**
   * Pobiera coefficient dla danego widthMultiplier z konfiguracji
   */
  private getCoefficientForWidthMultiplier(elementConfig: any, widthMultiplier: number): number {
    // Sprawdź czy coefficient jest obiektem z różnymi wartościami dla widthMultiplier
    if (elementConfig.coefficient && typeof elementConfig.coefficient === 'object') {
      const widthMultiplierKey = widthMultiplier.toString()
      return elementConfig.coefficient[widthMultiplierKey] || elementConfig.coefficient['1'] || 0.5
    }
    
    // Jeśli coefficient jest liczbą, użyj jej dla wszystkich widthMultiplier
    if (typeof elementConfig.coefficient === 'number') {
      return elementConfig.coefficient
    }
    
    // Domyślna wartość
    return 0.5
  }

  /**
   * Inicjalizuje geometryOffsetZ - WYWOŁYWANE RAZ
   */
  private initializeGeometryOffset(elementGroup: THREE.Group): void {
    console.log('🎯 initializeGeometryOffset START')
    
    // RESETUJ rotację do 0° żeby BoundingBox był stabilny
    const originalRotation = elementGroup.rotation.y
    const originalPosition = elementGroup.position.clone()
    const originalVisibility = new Map<THREE.Object3D, boolean>()
    
    console.log('  - originalRotation:', (originalRotation * 180 / Math.PI).toFixed(2), '°')
    console.log('  - originalPosition:', 'X:', originalPosition.x.toFixed(6), 'Z:', originalPosition.z.toFixed(6))
    
    // 🎯 WAŻNE: Dla gate/door w vision-bet/slim/gladkie NIE ignoruj ukrytych bloków przy obliczaniu bbox!
    // Ustaw tymczasowo wszystkie obiekty na visible=true, zapamiętując poprzedni stan,
    // żeby bounding box był liczony na podstawie CAŁEJ sekcji (jak dla section), a nie tylko metalu.
    elementGroup.traverse((obj: THREE.Object3D) => {
      originalVisibility.set(obj, obj.visible)
      obj.visible = true
    })

    elementGroup.rotation.y = 0
    
    const bbox = new THREE.Box3().setFromObject(elementGroup)
    const bboxCenter = new THREE.Vector3()
    bbox.getCenter(bboxCenter)
    
    console.log('  - position przy rot=0:', 'X:', elementGroup.position.x.toFixed(6), 'Z:', elementGroup.position.z.toFixed(6))
    console.log('  - bboxCenter przy rot=0:', 'X:', bboxCenter.x.toFixed(6), 'Z:', bboxCenter.z.toFixed(6))
    
    const geometryOffsetZ = bboxCenter.z - elementGroup.position.z
    elementGroup.userData.geometryOffsetZ = geometryOffsetZ
    
    console.log('  - geometryOffsetZ:', geometryOffsetZ.toFixed(6))
    
    // Przywróć widoczność obiektów
    elementGroup.traverse((obj: THREE.Object3D) => {
      const prev = originalVisibility.get(obj)
      if (prev !== undefined) {
        obj.visible = prev
      }
    })

    // Przywróć rotację
    elementGroup.rotation.y = originalRotation
    
    console.log('✅ Offset Z zapisany:', geometryOffsetZ.toFixed(6), 'dla elementu:', elementGroup.userData.fenceElementId)
    console.log('🎯 initializeGeometryOffset END')
  }

  // 🎯 Publiczna metoda do obliczania pivot point (dla Slim 3D)
  calculatePivotPoint(
    elementGroup: THREE.Group,
    _elements3D: Map<string, THREE.Group>
  ): THREE.Vector3 {
    // 🎯 Dla sections, gate, door: użyj baseWidth (1x), dla innych elementów: currentWidth
    // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long i slim-3d gate/door: traktuj jak section
    // 🎯 Użyj originalElementType dla gate/door, bo elementType może być 'section' (przez elementNameFor3D)
    const pivotElementType = elementGroup.userData?.originalElementType || elementGroup.userData?.elementType
    const pivotFenceConfig = elementGroup.userData?.fenceConfig
    const pivotFenceConfigId = pivotFenceConfig?.id
    const isVisionBetLong = pivotFenceConfigId === 'vision-bet-long'
    const isVisionBetMax = pivotFenceConfigId === 'vision-bet-max'
    const isVisionBetMedium = pivotFenceConfigId === 'vision-bet-medium'
    const isGladkieMedium = pivotFenceConfigId === 'gladkie_medium'
    const isGladkieMax = pivotFenceConfigId === 'gladkie_max'
    const isGladkieLong = pivotFenceConfigId === 'gladkie_long' || pivotFenceConfigId === 'slim3d-kopia'
    const isSlim3d = pivotFenceConfigId === 'slim-3d'
    const isSlim = pivotFenceConfigId === 'slim'
    const isRoyalS50 = pivotFenceConfigId === 'royal_s50'
    const isRoyalP50 = pivotFenceConfigId === 'royal_p50'
    const isMuroP22 = pivotFenceConfigId === 'lupane-muro-p22'
    const isMuroS22 = pivotFenceConfigId === 'lupane-muro-s22'
    const isMuroP38 = pivotFenceConfigId === 'lupane-muro-p38'
    const isVisionBetLongGateDoor = isVisionBetLong && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isVisionBetMaxGateDoor = isVisionBetMax && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isVisionBetMediumGateDoor = isVisionBetMedium && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isGladkieMediumGateDoor = isGladkieMedium && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isGladkieMaxGateDoor = isGladkieMax && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isGladkieLongGateDoor = isGladkieLong && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isSlim3dGateDoor = isSlim3d && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isSlimGateDoor = isSlim && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isRoyalS50GateDoor = isRoyalS50 && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isRoyalP50GateDoor = isRoyalP50 && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isMuroP22GateDoor = isMuroP22 && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isMuroS22GateDoor = isMuroS22 && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isMuroP38GateDoor = isMuroP38 && (pivotElementType === 'gate' || pivotElementType === 'door')
    const isVisionBetGateDoor = isVisionBetLongGateDoor || isVisionBetMaxGateDoor || isVisionBetMediumGateDoor || isGladkieMediumGateDoor || isGladkieMaxGateDoor || isGladkieLongGateDoor || isSlim3dGateDoor || isSlimGateDoor || isRoyalS50GateDoor || isRoyalP50GateDoor || isMuroP22GateDoor || isMuroS22GateDoor || isMuroP38GateDoor
    const isSection = elementGroup.name === 'section_group' || isVisionBetGateDoor
    const isGate = elementGroup.name === 'gate_group' && !isVisionBetGateDoor
    const isDoor = elementGroup.name === 'door_group' && !isVisionBetGateDoor
    const needsBaseWidth = isSection || isGate || isDoor
    const currentWidth = needsBaseWidth 
      ? (elementGroup.userData?.baseWidth || elementGroup.userData?.width || 2.0)
      : (elementGroup.userData?.width || 2.0)
    
    // 🎯 Dla sections z widthMultiplier > 1: pivot point powinien być w lewej krawędzi POJEDYNCZEGO bloczka
    // Użyj baseWidth żeby pivot był zawsze na lewej krawędzi pierwszego bloku, nie w środku całego elementu
    const isSlim3D = pivotFenceConfigId === 'slim-3d'
    const isSlim3DPost = isSlim3D && elementGroup.name === 'post_group'
    const isSlim3DSection = isSlim3D && elementGroup.name === 'section_group'
    const isSlim3DGateDoor = isSlim3D && isSlim3dGateDoor
    
    // 🎯 Dla wszystkich ogrodzeń (w tym Slim 3D): używaj standardowej logiki jak Gladkie Long
    // currentWidth już jest ustawione na baseWidth dla section/gate/door (linie 456-459)
    // NIE zmieniaj tej logiki dla Slim 3D - powinno działać jak Gladkie Long
    let actualWidth = currentWidth
    // 🎯 Dla P22/P38: używaj baseWidth (tak jak S22/S38), pivot point powinien być w lewej krawędzi pierwszego bloku
    // Usunięto specjalną logikę używającą width - powodowała błędny pivot point
    
    const currentPos = elementGroup.position.clone()
    const currentRotation = elementGroup.rotation.y

    console.log('📍 calculatePivotPoint:')
    console.log('  - currentPos:', 'X:', currentPos.x.toFixed(6), 'Z:', currentPos.z.toFixed(6))
    console.log('  - currentRotation:', (currentRotation * 180 / Math.PI).toFixed(2), '°')
    console.log('  - currentWidth:', currentWidth, isSection ? '(baseWidth dla section)' : '(width)')
    console.log('  - actualWidth:', actualWidth, isSection ? '(baseWidth dla section)' : '(width)')
    if (isSlim3D) {
      console.log(`  - 🎯 Slim 3D: używam standardowej logiki (jak Gladkie Long), actualWidth=${actualWidth.toFixed(3)}`)
    }
    console.log('  - elementGroup.userData:', {
      width: elementGroup.userData?.width,
      baseWidth: elementGroup.userData?.baseWidth,
      widthMultiplier: elementGroup.userData?.widthMultiplier,
      elementType: elementGroup.userData?.elementType
    })

    // 🎯 BACKUP: Użyj ZAPISANEGO offsetu Z
    // ✅ Dla Slim 3D gate/door zachowuj się TAK SAMO jak dla section
    // (bez wymuszania geometryOffsetZ = 0), żeby pivot/rotacja były 1:1 z przęsłem
    const geometryOffsetZ = elementGroup.userData?.geometryOffsetZ || 0
    console.log('  - geometryOffsetZ (zapisany):', geometryOffsetZ.toFixed(6))

    // 🎯 Pivot point w LEWEJ KRAWĘDZI elementu (nie w środku!)
    // Dla sections: actualWidth = width (cały element), więc pivot = -width/2 (lewa krawędź)
    // Dla posts: actualWidth = width, więc pivot = -width/2 (lewa krawędź)
    
    // 🎯 Dla Slim 3D gate/door: używaj width zamiast baseWidth i zeruj geometryOffsetZ
    let effectiveWidth = actualWidth
    let effectiveGeometryOffsetZ = geometryOffsetZ
    let slim3dGateExtraOffset = 0
    
    // 🎯 Dla P22 post: postOffsetZ jest teraz aplikowany PO rotacji (TYLKO wizualne), więc nie wpływa na geometryOffsetZ
    // Nie ma potrzeby odejmowania postOffsetZ od geometryOffsetZ
    
    if (isSlim3DGateDoor) {
      // Dla Slim 3D gate: użyj pełnej szerokości (width) zamiast baseWidth
      effectiveWidth = elementGroup.userData?.width || actualWidth
      effectiveGeometryOffsetZ = 0
      slim3dGateExtraOffset = -0.19 // 🎯 Dodatkowe przesunięcie pivot point w lewo
      console.log(`  - 🎯 Slim 3D gate/door: effectiveWidth=${effectiveWidth.toFixed(3)}, extraOffset=${slim3dGateExtraOffset}`)
    }
    
    let leftEdgeOffset = new THREE.Vector3(-effectiveWidth / 2 + slim3dGateExtraOffset, 0, effectiveGeometryOffsetZ)
    
    // 🎯 Slim 3D post: pivot point w lewej krawędzi (używamy width, nie baseWidth)
    if (isSlim3DPost) {
      leftEdgeOffset = new THREE.Vector3(-currentWidth / 2, 0, geometryOffsetZ)
      console.log(`  - 🎯 Slim 3D post: używam width=${currentWidth.toFixed(3)} dla pivot point`)
    }
    
    // 🎯 FIX dla sections, gate, door: pivot powinien być w lewej krawędzi pierwszego bloku
    // Dla wszystkich widthMultiplier dodajemy dodatkowy offset żeby pivot był na początku, nie w środku
    if (isSection || isGate || isDoor) {
      const widthMultiplier = elementGroup.userData.widthMultiplier || 1
      
      // 🎯 Standardowa logika dla wszystkich ogrodzeń (w tym Muro P22)
      {
        // Standardowa logika dla innych ogrodzeń
        // Użyj mapy dla konkretnej konfiguracji, jeśli dostępna
        let extraOffset = 0
        
        // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long i slim-3d gate/door: używaj offsetów z section (takich samych jak section)
        // 🚪 Dla gate/door (nie vision-bet-long/max/medium/gladkie-max/gladkie-long/slim-3d): użyj własnych offsetów (są takie same dla wszystkich configów)
        // 🎯 Dla slim-3d gate/door: NIE używaj extraOffset - pivot jest już w odpowiednim miejscu
        if (isSlim3DGateDoor) {
          extraOffset = 0
          console.log(`  - 🎯 Slim 3D gate/door: extraOffset=0 (używamy pełnej szerokości)`)
        } else if ((isSection || isVisionBetGateDoor) && pivotFenceConfigId && SECTION_ROTATION_OFFSETS[pivotFenceConfigId]) {
          // Dla section i vision-bet gate/door (w tym slim-3d): użyj offsetów z fenceConfigId (takich samych jak section)
          extraOffset = SECTION_ROTATION_OFFSETS[pivotFenceConfigId][widthMultiplier] || 0
          if (isVisionBetGateDoor) {
            let fenceType = ''
            if (isVisionBetLong) fenceType = 'Vision-Bet-Long'
            else if (isVisionBetMax) fenceType = 'Vision-Bet-Max'
            else if (isVisionBetMedium) fenceType = 'Vision-Bet-Medium'
            else if (isGladkieMax) fenceType = 'Gladkie-Max'
            else if (isGladkieLong) fenceType = 'Gladkie-Long'
            else if (isSlim3d) fenceType = 'Slim-3D'
            else if (isSlim) fenceType = 'Slim'
            else if (isMuroP22) fenceType = 'Muro-P22'
            else if (isMuroS22) fenceType = 'Muro-S22'
            else if (isMuroP38) fenceType = 'Muro-P38'
            console.log(`  - 🚪 ${fenceType} ${pivotElementType}: używam offsetów z section (${pivotFenceConfigId}):`, widthMultiplier + 'x =', extraOffset)
          } else {
            console.log(`  - Section (${pivotFenceConfigId}): używam offsetów:`, widthMultiplier + 'x =', extraOffset)
          }
        } else if (isGate && SECTION_ROTATION_OFFSETS['gate']) {
          extraOffset = SECTION_ROTATION_OFFSETS['gate'][widthMultiplier] || 0
        } else if (isDoor && SECTION_ROTATION_OFFSETS['door']) {
          extraOffset = SECTION_ROTATION_OFFSETS['door'][widthMultiplier] || 0
        }
        
        leftEdgeOffset.x += extraOffset
        console.log(`  - Dodano extraOffset dla ${elementGroup.name}:`, widthMultiplier + 'x =', extraOffset)
      }
    }
    console.log('  - leftEdgeOffset (przed rotacją):', 'X:', leftEdgeOffset.x.toFixed(6), 'Z:', leftEdgeOffset.z.toFixed(6))
    
    leftEdgeOffset.applyEuler(new THREE.Euler(0, currentRotation, 0))
    console.log('  - leftEdgeOffset (po rotacji):', 'X:', leftEdgeOffset.x.toFixed(6), 'Z:', leftEdgeOffset.z.toFixed(6))
    
    // 🎯 DODAJ rightOffset do pivot point (jeśli element ma rightOffset)
    const rightOffset = elementGroup.userData?.rightOffset || 0
    if (rightOffset !== 0) {
      const rightOffsetVector = new THREE.Vector3(rightOffset, 0, 0)
      rightOffsetVector.applyEuler(new THREE.Euler(0, currentRotation, 0))
      leftEdgeOffset.add(rightOffsetVector)
      console.log('  - rightOffset dodany do pivot:', 'X:', rightOffsetVector.x.toFixed(6), 'Z:', rightOffsetVector.z.toFixed(6))
    }
    
    const pivotPoint = currentPos.clone().add(leftEdgeOffset)
    console.log('  - pivotPoint FINAL (backup):', 'X:', pivotPoint.x.toFixed(6), 'Z:', pivotPoint.z.toFixed(6))
    
    return pivotPoint
  }

  calculateNextElementPosition(
    previousElement: THREE.Group,
    elementWidth: number,
    _elements3D: Map<string, THREE.Group>,
    nextElementType?: 'post' | 'section' | 'gate' | 'door',
    selectedVariant?: string
  ): { x: number; y: number; z: number; rotation: number } {
    console.log('🔍 calculateNextElementPosition START')
    
    const prevInheritedRotation = previousElement.userData?.inheritedRotation || 0
    const prevSliderRotation = previousElement.userData?.rotation || 0
    const previousAbsoluteRotation = prevInheritedRotation - prevSliderRotation
    
    const previousElementWidth = previousElement.userData?.width || 2.0
    const previousRotationRad = previousElement.rotation.y

    console.log('  - prevAbsoluteRotation:', previousAbsoluteRotation)
    console.log('  - prevRotation (rad):', previousRotationRad)
    console.log('  - prevWidth:', previousElementWidth)

    let contactPoint: THREE.Vector3
    
    // 🎯 Używamy originalElementType, bo dla gate/door elementType może być 'section' (przez elementNameFor3D)
    const previousElementType = previousElement.userData?.originalElementType || previousElement.userData?.elementType
    
    // 🎯 Dla Muro Mix: używaj rightEdge z userData (podobnie jak dla Royal Mix)
    const isMuroMix = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix'
    const isMuroMixP22 = isMuroMix && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22'
    const isMuroMixP38 = isMuroMix && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38'
    const isMuroMixS22 = isMuroMix && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22'
    const isMuroMixS38 = isMuroMix && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s38'
    
    // 🎯 Dla Muro P22 section: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ ALE: Dla Muro Mix + P22 używaj rightEdge z userData
    const isMuroP22Section = previousElement.userData?.elementType === 'section' && 
                             previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22' &&
                             !isMuroMixP22 // ⚠️ Dla Muro Mix P22 NIE obliczaj z pozycji - użyj rightEdge z userData
    // 🎯 Dla Muro P38 section i gate/door: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // Gate/door w P38 jest traktowane identycznie jak section
    // ⚠️ ALE: Dla Muro Mix + P38 używaj rightEdge z userData
    const isMuroP38Section = previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38' &&
                             !isMuroMixP38 && // ⚠️ Dla Muro Mix P38 NIE obliczaj z pozycji - użyj rightEdge z userData
                             (previousElementType === 'section' || previousElementType === 'gate' || previousElementType === 'door')
    // 🎯 Dla Muro S22 section: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ ALE: Dla Muro Mix + S22 używaj rightEdge z userData
    const isMuroS22Section = previousElement.userData?.elementType === 'section' && 
                             previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22' &&
                             !isMuroMixS22 // ⚠️ Dla Muro Mix S22 NIE obliczaj z pozycji - użyj rightEdge z userData
    // 🎯 Dla Muro S38 section: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ ALE: Dla Muro Mix + S38 używaj rightEdge z userData
    const isMuroS38Section = previousElement.userData?.elementType === 'section' && 
                             previousElement.userData?.fenceConfig?.id === 'lupane-muro-s38' &&
                             !isMuroMixS38 // ⚠️ Dla Muro Mix S38 NIE obliczaj z pozycji - użyj rightEdge z userData
    // 🎯 Dla Royal S50 section/gate/door: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    const isRoyalS50Section =
      previousElement.userData?.fenceConfig?.id === 'royal_s50' &&
      (previousElementType === 'section' ||
        previousElementType === 'gate' ||
        previousElementType === 'door')
    // 🎯 Dla Royal P50 section/gate/door: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ ALE: Dla Royal Mix + P50 używaj rightEdge z userData (bo position ma przesunięcie wizualne)
    const isRoyalMixP50 = previousElement.userData?.originalFenceConfigId === 'royal-mix' && previousElement.userData?.fenceConfig?.id === 'royal_p50'
    const isRoyalP50Section =
      previousElement.userData?.fenceConfig?.id === 'royal_p50' &&
      !isRoyalMixP50 && // ⚠️ Dla Royal Mix P50 NIE obliczaj z pozycji - użyj rightEdge z userData
      (previousElementType === 'section' ||
        previousElementType === 'gate' ||
        previousElementType === 'door')
    // 🎯 Dla Muro P22: gdy dodajemy gate/door po post, oblicz rightEdge bezpośrednio (jak dla section po post)
    const isMuroP22PostToGateDoor =
      previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22' &&
      previousElementType === 'post' &&
      (nextElementType === 'gate' || nextElementType === 'door')
    // 🎯 Dla Muro S22: gdy dodajemy gate/door po post - użyj tej samej logiki co P22
    const isMuroS22PostToGateDoor =
      previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22' &&
      previousElementType === 'post' &&
      (nextElementType === 'gate' || nextElementType === 'door')
    // 🎯 Dla Muro P38: gdy dodajemy gate/door po post - użyj tej samej logiki co P22
    // ⚠️ UWAGA: Dla Muro Mix P38 NIE używamy tego bloku - przypadek 4 w bloku Muro Mix obsługuje to
    const isMuroP38PostToGateDoor =
      previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38' &&
      !isMuroMix && // ⚠️ Wyklucz Muro Mix - przypadek 4 w bloku Muro Mix obsługuje to
      previousElementType === 'post' &&
      (nextElementType === 'gate' || nextElementType === 'door')
    // 🎯 Dla Muro P22 gate/door: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ NIE modyfikować logiki dla section - tylko dla gate/door
    const isMuroP22SectionLike =
      previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22' &&
      (previousElementType === 'gate' ||
        previousElementType === 'door')
    // 🎯 Dla Muro S22 gate/door: zawsze używaj bezpośredniego obliczenia (bez zapisanego rightEdge)
    // ⚠️ NIE modyfikować logiki dla section - tylko dla gate/door
    const isMuroS22SectionLike =
      previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22' &&
      (previousElementType === 'gate' ||
        previousElementType === 'door')
    // 🎯 Dla Slim 3D section/gate/door: zawsze obliczaj rightEdge bezpośrednio z width/rotacji
    const isSlim3DSectionLike =
      previousElement.userData?.fenceConfig?.id === 'slim-3d' &&
      (previousElementType === 'section' ||
        previousElementType === 'gate' ||
        previousElementType === 'door')
    
    console.log('  - 🔍 Sprawdzam previousElement.userData?.rightEdge:', previousElement.userData?.rightEdge ? 'ISTNIEJE ✅' : 'NIE MA ❌')
    console.log('  - 🔍 previousElement.userData:', previousElement.userData)
    console.log('  - 🔍 previousElementType:', previousElementType)
    console.log('  - 🔍 previousElement.userData?.originalElementType:', previousElement.userData?.originalElementType)
    console.log('  - 🔍 previousElement.userData?.elementType:', previousElement.userData?.elementType)
    console.log('  - 🔍 previousElement.userData?.fenceConfig?.id:', previousElement.userData?.fenceConfig?.id)
    console.log('  - 🔍 isMuroMix:', isMuroMix)
    console.log('  - 🔍 isMuroMixP22:', isMuroMixP22)
    console.log('  - 🔍 isMuroMixP38:', isMuroMixP38)
    console.log('  - 🔍 isMuroMixS22:', isMuroMixS22)
    console.log('  - 🔍 isMuroMixS38:', isMuroMixS38)
    console.log('  - 🔍 isMuroP22Section:', isMuroP22Section)
    console.log('  - 🔍 isMuroP38Section:', isMuroP38Section)
    console.log('  - 🔍 isMuroS22Section:', isMuroS22Section)
    console.log('  - 🔍 isMuroS38Section:', isMuroS38Section)
    console.log('  - 🔍 isRoyalS50Section:', isRoyalS50Section)
    console.log('  - 🔍 isRoyalP50Section:', isRoyalP50Section)
    console.log('  - 🔍 isMuroP22PostToGateDoor:', isMuroP22PostToGateDoor)
    console.log('  - 🔍 isMuroS22PostToGateDoor:', isMuroS22PostToGateDoor)
    console.log('  - 🔍 isMuroP38PostToGateDoor:', isMuroP38PostToGateDoor)
    
    if (isMuroP22PostToGateDoor) {
      // 🎯 Dla Muro P22: gdy dodajemy gate/door po post, oblicz rightEdge bezpośrednio z pozycji posta
      // Post ma szerokość = spacing * 2 = 0.148, więc rightEdge = pozycja + (szerokość / 2) = pozycja + 0.074
      // Ale post nie ma odjętego spacing w swoim rightEdge, więc musimy odjąć spacing, żeby gate/door było w odpowiednim miejscu
      // Odejmujemy spacing (0.074), żeby contactPoint był w prawej krawędzi posta (bez odstępu)
      console.log('  - 🎯 Muro P22 post -> gate/door: obliczam rightEdge bezpośrednio (bez zapisanego)')
      
      const prevPos = previousElement.position.clone()
      const fenceConfig = previousElement.userData?.fenceConfig
      const postConfig = fenceConfig?.elements?.post
      const postSpacing = postConfig?.spacing || 0.074
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - postSpacing:', postSpacing.toFixed(3))
      console.log('    - previousElementWidth:', previousElementWidth.toFixed(3))
      
      // Oblicz rightEdge bezpośrednio z pozycji posta i jego szerokości
      // Post ma szerokość = spacing * 2 = 0.148, więc rightEdge = pozycja + (szerokość / 2) = pozycja + 0.074
      // Ale post nie ma odjętego spacing w swoim rightEdge (w przeciwieństwie do section)
      // Dla gate/door po post musimy odjąć spacing, żeby usunąć odstęp po lewej stronie
      // (dla section po post działa dobrze, bo section ma odjęte spacing w swoim rightEdge)
      let rightEdgeOffsetX = previousElementWidth / 2
      
      // Odejmij 3.85x spacing post od rightEdge (przesuń w lewo), żeby zmniejszyć odstęp z lewej strony
      // Post ma rightEdge w pozycji + (width/2), ale nie ma odjętego spacing, więc musimy to skorygować
      rightEdgeOffsetX -= postSpacing * 3.85
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🚪 Dla Muro Mix P22: dodaj lekki offset od lewej dla zrotowanego 2x gate/door
      const isMuroMixP22ForLeftOffset = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix'
      if (isMuroMixP22ForLeftOffset) {
        const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier
        const previousAbsoluteRotation = previousElement.userData?.absoluteRotation || 0
        const isPreviousRotated = Math.abs(previousAbsoluteRotation) > 0.01
        console.log(`🔍 Muro Mix P22 post -> gate/door: __nextElementWidthMultiplier=${nextWidthMultiplier}, isPreviousRotated=${isPreviousRotated}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
        // TYLKO dla 2x I TYLKO dla zrotowanych
        if (nextWidthMultiplier === 2 && isPreviousRotated) {
          const sectionConfig = fenceConfig?.elements?.section
          const sectionSpacing = sectionConfig?.spacing || 0.074
          // Dla 2x: lekki offset od lewej (przesuń w prawo o 0.3x spacing)
          const leftOffsetMultiplier = -0.3
          const leftOffset = sectionSpacing * leftOffsetMultiplier
          const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
          leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(leftOffsetVector)
          console.log(`🚪 Muro Mix P22: post -> gate/door (${nextWidthMultiplier}x), dodano offset od lewej ${leftOffset.toFixed(3)}m`)
          console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu offsetu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else {
          console.log(`🚪 Muro Mix P22: post -> gate/door (${nextWidthMultiplier || 'nie ustawione'}x), NIE dodaję offsetu od lewej (tylko dla zrotowanych 2x)`)
        }
        // 🎯 Wyczyść __nextElementWidthMultiplier po użyciu
        ;(window as any).__nextElementWidthMultiplier = undefined
      }
      
      console.log('    - rightEdgeOffsetX (przed rotacją):', rightEdgeOffsetX.toFixed(6))
      console.log('    - rightEdgeOffset (po rotacji):', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro P22 post -> gate/door):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroS22PostToGateDoor) {
      // 🎯 Dla Muro S22: korekta postSpacing * 1.5 (mniejsza niż P22)
      console.log('  - 🎯 Muro S22 post -> gate/door: korekta 1.5x postSpacing')
      
      const prevPos = previousElement.position.clone()
      const fenceConfig = previousElement.userData?.fenceConfig
      const postConfig = fenceConfig?.elements?.post
      const postSpacing = postConfig?.spacing || 0.092
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - postSpacing:', postSpacing.toFixed(3))
      console.log('    - previousElementWidth:', previousElementWidth.toFixed(3))
      
      // 🎯 Dla S22: mniejsza korekta niż P22 (1.35x zamiast 2x)
      let rightEdgeOffsetX = previousElementWidth / 2
      rightEdgeOffsetX -= postSpacing * 1.35
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🚪 Dla niezrotowanych gate/door w S22: zmniejsz odstęp po lewej
      const isRotated = Math.abs(previousRotationRad) > 0.01
      const isRotatedAbsolute = Math.abs(previousAbsoluteRotation) > 0.01
      const isNotRotated = !isRotated && !isRotatedAbsolute
      
      console.log(`🔍 DEBUG S22 gate/door left offset: isRotated=${isRotated}, isRotatedAbsolute=${isRotatedAbsolute}, isNotRotated=${isNotRotated}, previousRotationRad=${previousRotationRad}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
      
      // Dla niezrotowanych i zrotowanych gate/door w S22: ustaw odstęp po lewej
      const sectionConfig = fenceConfig?.elements?.section
      const sectionSpacing = sectionConfig?.spacing || 0.086
      const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier || 1
      console.log(`🔍 DEBUG S22 gate/door: nextWidthMultiplier=${nextWidthMultiplier}, sectionSpacing=${sectionSpacing}, isNotRotated=${isNotRotated}`)
      
      // Dla 2x: zwiększ odstęp po lewej (tak samo dla zrotowanych i niezrotowanych)
      let leftOffsetMultiplier = -0.2
      if (nextWidthMultiplier === 2) {
        leftOffsetMultiplier = 1.4 // Dla 2x: offset po lewej
      }
      
      const leftOffset = sectionSpacing * leftOffsetMultiplier
      const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
      leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      // Dla zrotowanych: używaj leftOffsetVector.z (prawidłowe przesunięcie po rotacji)
      // Dla niezrotowanych: zachowaj wartość Z
      contactPoint = new THREE.Vector3(
        contactPoint.x + leftOffsetVector.x,
        contactPoint.y + leftOffsetVector.y,
        isNotRotated ? contactPoint.z : contactPoint.z + leftOffsetVector.z
      )
      console.log(`✅ Muro S22: post -> gate/door (${nextWidthMultiplier}x, ${isNotRotated ? 'niezrotowany' : 'zrotowany'}), ustawiono odstęp po lewej o ${leftOffset.toFixed(3)}m`)
      console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
      console.log(`  - contactPoint po ustawieniu odstępu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      // Wyczyść __nextElementWidthMultiplier po użyciu
      ;(window as any).__nextElementWidthMultiplier = undefined
      
      console.log('    - rightEdgeOffsetX (przed rotacją):', rightEdgeOffsetX.toFixed(6))
      console.log('    - rightEdgeOffset (po rotacji):', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro S22 post -> gate/door):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroP38PostToGateDoor) {
      // 🎯 Dla Muro P38: gdy dodajemy gate/door po post, zawsze oblicz rightEdge bezpośrednio z pozycji posta (tak jak w P22)
      // Zawsze obliczamy bezpośrednio, bez sprawdzania rotacji - previousRotationRad już uwzględnia rotację
      console.log('  - 🎯 Muro P38 post -> gate/door: obliczam rightEdge bezpośrednio (bez zapisanego, jak w P22)')
      
      const prevPos = previousElement.position.clone()
      const fenceConfig = previousElement.userData?.fenceConfig
      const postConfig = fenceConfig?.elements?.post
      const postSpacing = postConfig?.spacing || 0.074
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - postSpacing:', postSpacing.toFixed(3))
      console.log('    - previousElementWidth:', previousElementWidth.toFixed(3))
      console.log('    - previousAbsoluteRotation:', previousAbsoluteRotation.toFixed(1) + '°')
      console.log('    - previousRotationRad:', previousRotationRad.toFixed(6))
      
      // Oblicz rightEdge bezpośrednio z pozycji posta i jego szerokości
      // Post ma szerokość = spacing * 2 = 0.148, więc rightEdge = pozycja + (szerokość / 2) = pozycja + 0.074
      // Dla P38: dodajemy spacing zamiast odejmować (P38 ma inną geometrię niż P22)
      // Zmniejszamy odstęp po lewej stronie (post -> gate) dla wszystkich multipliers
      let rightEdgeOffsetX = previousElementWidth / 2
      rightEdgeOffsetX -= postSpacing * -0.135 // Dokładnie 10mm (0.074m * 0.135 ≈ 10mm)
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      console.log('    - rightEdgeOffsetX (przed rotacją):', rightEdgeOffsetX.toFixed(6))
      console.log('    - rightEdgeOffset (po rotacji):', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro P38 post -> gate/door):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroP22Section) {
      // 🎯 Dla Muro P22: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 3: odejmij kompensację (widthMultiplier - 2) * spacing * 0.5
      console.log('  - 🎯 Muro P22 section: obliczam rightEdge bezpośrednio (bez zapisanego)')
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.074
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 2) {
        // Różne kompensacje dla różnych widthMultiplier
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -1.0 // -0.074 dla 2x (dodaje zamiast odejmować)
        } else if (widthMultiplier === 3) {
          reduction = spacing * 0.0 // 0.0 dla 3x
        } else if (widthMultiplier === 4) {
          reduction = spacing * 1.0 // 0.074 dla 4x
        } else if (widthMultiplier === 5) {
          reduction = spacing * 2.0 // 0.148 dla 5x
        }
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Muro P22: gdy dodajemy post po section/gate/door, dodaj spacing section od rightEdge
      if ((previousElementType === 'section' || previousElementType === 'gate' || previousElementType === 'door') && nextElementType === 'post') {
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
        const spacingOffset = new THREE.Vector3(spacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Muro P22: ${previousElementType} -> post, dodano spacing section ${spacing.toFixed(3)}m do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro P22):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroP38Section) {
      // 🎯 Dla Muro P38: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 2: odejmij kompensację
      console.log('  - 🎯 Muro P38 section: obliczam rightEdge bezpośrednio (bez zapisanego)')
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.074
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 2) {
        // Dla P38: im większy multiplier, tym WIĘKSZY dodatni odstęp (więcej ujemnej reduction)
        // żeby słupek miał odpowiedni odstęp od bramy
        const isRotated = Math.abs(previousRotationRad) > 0.01
        const isRotatedAbsolute = Math.abs(previousAbsoluteRotation) > 0.01
        const isNotRotated = !isRotated && !isRotatedAbsolute
        
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -1.0 // -0.074 dla 2x (dodaje 74mm spacing)
        } else if (widthMultiplier === 3) {
          // Dla niezrotowanych 3x: zwiększ kompensację, żeby słupek nie nachodził
          reduction = isNotRotated ? spacing * -4.0 : spacing * -2.6 // -0.296 dla niezrotowanych, -0.192 dla zrotowanych
        } else if (widthMultiplier === 4) {
          // Dla niezrotowanych 4x: zwiększ kompensację
          reduction = isNotRotated ? spacing * -4.5 : spacing * -3.1 // -0.333 dla niezrotowanych, -0.229 dla zrotowanych
        } else if (widthMultiplier === 5) {
          // Dla niezrotowanych 5x: zwiększ kompensację
          reduction = isNotRotated ? spacing * -5.0 : spacing * -3.6 // -0.370 dla niezrotowanych, -0.266 dla zrotowanych
        }
        rightEdgeOffsetX -= reduction
        console.log(`    - kompensacja dla ${widthMultiplier}x (${isNotRotated ? 'niezrotowany' : 'zrotowany'}): ${reduction.toFixed(3)}m`)
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Muro P38: gdy dodajemy gate/door po section/gate/door, dodaj małą korektę dla zrotowanych elementów
      // W P38 section spacing = post spacing (0.074), więc działa tak samo jak w P22
      // Gate/door w P38 jest traktowane identycznie jak section
      if ((previousElementType === 'section' || previousElementType === 'gate' || previousElementType === 'door') && (nextElementType === 'gate' || nextElementType === 'door')) {
        // Dodaj małą korektę (0.15x spacing = 0.011m) żeby bramy nie nachodziły na siebie po rotacji
        const spacingOffset = new THREE.Vector3(spacing * 0.15, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Muro P38: ${previousElementType} -> ${nextElementType}, dodano małą korektę ${(spacing * 0.15).toFixed(3)}m dla rotacji`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po korekcie: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro P38):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroS22Section) {
      // 🎯 Dla Muro S22: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 2: odejmij kompensację
      console.log('  - 🎯 Muro S22 section: obliczam rightEdge bezpośrednio (bez zapisanego)')
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.086
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 2) {
        // Różne kompensacje dla różnych widthMultiplier
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -0.9 // -0.077 dla 2x (dodaje zamiast odejmować)
        } else if (widthMultiplier === 3) {
          reduction = spacing * 0.0 // 0.0 dla 3x
        } else if (widthMultiplier === 4) {
          reduction = spacing * 0.9 // 0.077 dla 4x
        } else if (widthMultiplier === 5) {
          reduction = spacing * 1.8 // 0.155 dla 5x
        }
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Muro S22: gdy dodajemy post po section, dodaj spacing section od rightEdge
      if (previousElementType === 'section' && nextElementType === 'post') {
        const isRotated = Math.abs(previousRotationRad) > 0.01
        const isRotatedAbsolute = Math.abs(previousAbsoluteRotation) > 0.01
        const isNotRotated = !isRotated && !isRotatedAbsolute
        
        // Dla niezrotowanych 3x, 4x, 5x: zwiększ spacing, żeby słupek nie nachodził (tak jak w P22)
        let spacingMultiplier = 1.0
        console.log(`🔍 DEBUG S22 spacing: previousElementType=${previousElementType}, widthMultiplier=${widthMultiplier}, isNotRotated=${isNotRotated}, isRotated=${isRotated}, isRotatedAbsolute=${isRotatedAbsolute}`)
        if (isNotRotated && widthMultiplier >= 3) {
          if (widthMultiplier === 3) {
            spacingMultiplier = 1.5 // Zwiększony spacing dla niezrotowanych 3x
          } else if (widthMultiplier === 4) {
            spacingMultiplier = 2.3 // Zwiększony spacing dla niezrotowanych 4x
          } else if (widthMultiplier === 5) {
            spacingMultiplier = 3.0 // Zwiększony spacing dla niezrotowanych 5x
          }
          console.log(`✅ S22: Używam spacingMultiplier=${spacingMultiplier} dla niezrotowanej ${widthMultiplier}x section`)
        } else {
          console.log(`❌ S22: NIE używam zwiększonego spacingMultiplier - isNotRotated=${isNotRotated}, widthMultiplier=${widthMultiplier}`)
        }
        
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
        const spacingOffset = new THREE.Vector3(spacing * spacingMultiplier, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        // Dla niezrotowanych: zachowaj wartość Z
        contactPoint = new THREE.Vector3(
          contactPoint.x + spacingOffset.x,
          contactPoint.y + spacingOffset.y,
          isNotRotated ? contactPoint.z : contactPoint.z + spacingOffset.z
        )
        console.log(`🎯 Muro S22: section (${widthMultiplier}x, ${isNotRotated ? 'niezrotowany' : 'zrotowany'}) -> post, dodano spacing section ${(spacing * spacingMultiplier).toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      // 🎯 Dla Muro S22: gdy dodajemy gate/door po section, odejmij spacing section od rightEdge DWA RAZY
      // W P22 section spacing = post spacing (0.074), więc działa automatycznie
      // W S22 section spacing (0.086) różni się od post spacing (0.092), więc trzeba odjąć section spacing dwa razy
      // (tak jak dla post -> gate/door odejmujemy postSpacing dwa razy)
      if (previousElementType === 'section' && (nextElementType === 'gate' || nextElementType === 'door')) {
        // Odejmij spacing section od contactPoint dwa razy (przesuń w lewo o spacing * 2)
        const spacingOffset = new THREE.Vector3(-spacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        // Drugi raz
        const spacingOffset2 = new THREE.Vector3(-spacing, 0, 0)
        spacingOffset2.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset2)
        console.log(`🎯 Muro S22: section -> ${nextElementType}, odjęto spacing section ${spacing.toFixed(3)}m DWA RAZY (razem ${(spacing * 2).toFixed(3)}m) od rightEdge`)
        console.log(`  - spacingOffset (pierwszy): X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - spacingOffset (drugi): X=${spacingOffset2.x.toFixed(6)}, Z=${spacingOffset2.z.toFixed(6)}`)
        console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro S22):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroS38Section) {
      // 🎯 Dla Muro S38: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 2: odejmij kompensację
      console.log('  - 🎯 Muro S38 section: obliczam rightEdge bezpośrednio (bez zapisanego)')
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.074
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 2) {
        // Różne kompensacje dla różnych widthMultiplier
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -0.9 // -0.067 dla 2x (dodaje zamiast odejmować)
        } else if (widthMultiplier === 3) {
          reduction = spacing * 0.0 // 0.0 dla 3x
        } else if (widthMultiplier === 4) {
          reduction = spacing * 0.9 // 0.067 dla 4x
        } else if (widthMultiplier === 5) {
          reduction = spacing * 1.8 // 0.133 dla 5x
        }
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Muro S38: gdy dodajemy post po section, dodaj spacing section od rightEdge
      if (previousElementType === 'section' && nextElementType === 'post') {
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
        const spacingOffset = new THREE.Vector3(spacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Muro S38: section -> post, dodano spacing section ${spacing.toFixed(3)}m do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro S38):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isRoyalS50Section) {
      // 🎯 Dla Royal S50 section/gate/door: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 3: odejmij kompensację (widthMultiplier - 2) * spacing * 0.5
      const royalS50ElementType = previousElementType === 'section' ? 'section' : (previousElementType === 'gate' ? 'gate' : 'door')
      console.log(`  - 🎯 Royal S50 ${royalS50ElementType}: obliczam rightEdge bezpośrednio (bez zapisanego)`)
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.198
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 3
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 3) {
        // Odejmij kompensację: (widthMultiplier - 2) * spacing * 0.5
        const reduction = (widthMultiplier - 2) * spacing * 0.5
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Royal S50: gdy dodajemy section/gate/door po post, odejmij spacing post od rightEdge
      if (previousElementType === 'post' && (nextElementType === 'section' || nextElementType === 'gate' || nextElementType === 'door')) {
        const postConfig = previousElement.userData?.fenceConfig?.elements?.post
        const postSpacing = postConfig?.spacing || 0.099
        // Odejmij spacing post od contactPoint (przesuń w lewo o spacing)
        const spacingOffset = new THREE.Vector3(-postSpacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Royal S50: post -> ${nextElementType}, odjęto spacing post ${postSpacing.toFixed(3)}m od rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        
        // 🚪 Dla gate/door 2x w Royal S50: zwiększ lekko odstęp od lewej
        // Zastosuj offset od lewej TYLKO dla zrotowanych gate/door 2x
        if ((nextElementType === 'gate' || nextElementType === 'door')) {
          // Pobierz widthMultiplier z kontekstu (będzie ustawiony w ElementToolbar)
          const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier
          // Sprawdź, czy poprzedni element jest zrotowany (jeśli tak, następny też będzie zrotowany)
          const isPreviousRotated = Math.abs(previousAbsoluteRotation) > 0.01
          console.log(`🔍 Royal S50: post -> ${nextElementType}, __nextElementWidthMultiplier=${nextWidthMultiplier}, isPreviousRotated=${isPreviousRotated}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
          // TYLKO dla 2x I TYLKO dla zrotowanych - jeśli nie jest ustawione, nie jest 2, lub nie jest zrotowany, nie dodawaj offsetu
          if (nextWidthMultiplier === 2 && isPreviousRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            // Dla 2x: większy offset od lewej (przesuń w prawo o 0.25x spacing)
            const leftOffsetMultiplier = -0.25
            const leftOffset = sectionSpacing * leftOffsetMultiplier
            const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
            leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(leftOffsetVector)
            console.log(`🚪 Royal S50: post -> ${nextElementType} (${nextWidthMultiplier}x), dodano offset od lewej ${leftOffset.toFixed(3)}m`)
            console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu offsetu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else {
            console.log(`🚪 Royal S50: post -> ${nextElementType} (${nextWidthMultiplier || 'nie ustawione'}x), NIE dodaję offsetu od lewej (tylko dla zrotowanych 2x)`)
          }
          // 🎯 Wyczyść __nextElementWidthMultiplier po użyciu, żeby nie było problemów z kolejnymi elementami
          ;(window as any).__nextElementWidthMultiplier = undefined
        }
      }
      
      // 🎯 Dla Royal S50: gdy dodajemy post/section po gate/door/section, dodaj spacing dla zrotowanych 2x
      // Dla section -> post: NIE dodawaj spacing (brak odstępu), ALE dla zrotowanych section 2x: dodaj spacing
      if ((previousElementType === 'gate' || previousElementType === 'door' || previousElementType === 'section') && (nextElementType === 'post' || nextElementType === 'section')) {
        const widthMultiplier = previousElement.userData?.widthMultiplier || 1
        const previousRotation = previousElement.userData?.absoluteRotation || 0
        const isRotated = Math.abs(previousRotation) > 0.01
        
        // 🚪 Dla gate/door 2x, 3x, 4x i 5x: dodaj spacing TYLKO dla zrotowanych (zwiększ odstęp po prawej)
        // Dla zrotowanych 2x: spacing (0.97x), dla zrotowanych 3x, 4x i 5x: spacing (0x)
        // Dla niezrotowanych: brak spacing (0x)
        if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && isRotated) {
          const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
          const sectionSpacing = sectionConfig?.spacing || 0.198
          let spacingMultiplier = 0
          if (widthMultiplier === 2) {
            spacingMultiplier = -0.3
          } else if (widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) {
            spacingMultiplier = -0.25
          }
          const spacingValue = sectionSpacing * spacingMultiplier
          // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
          const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
          spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(spacingOffset)
          console.log(`🚪 Royal S50: ${previousElementType} (${widthMultiplier}x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
          console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && !isRotated) {
          console.log(`🚪 Royal S50: ${previousElementType} (${widthMultiplier}x, NIE-ZROTOWANY) -> ${nextElementType}, NIE dodaję spacing (tylko dla zrotowanych)`)
        }
        // Dla section: NIE dodawaj spacing (brak odstępu) - zarówno dla zrotowanych jak i niezrotowanych
        // Dla innych przypadków: NIE dodawaj spacing (jak w S50)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Royal S50):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isRoyalP50Section) {
      // 🎯 Dla Royal P50 section/gate/door: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // To zapewnia spójność z syncElementRotation
      // Dla widthMultiplier >= 3: odejmij kompensację (widthMultiplier - 2) * spacing * 0.5
      const royalP50ElementType = previousElementType === 'section' ? 'section' : (previousElementType === 'gate' ? 'gate' : 'door')
      console.log(`  - 🎯 Royal P50 ${royalP50ElementType}: obliczam rightEdge bezpośrednio (bez zapisanego)`)
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.198
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))
      
      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 3
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 3) {
        // Odejmij kompensację: (widthMultiplier - 2) * spacing * 0.5
        const reduction = (widthMultiplier - 2) * spacing * 0.5
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }
      
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Royal P50: gdy dodajemy section/gate/door po post, odejmij spacing post od rightEdge
      if (previousElementType === 'post' && (nextElementType === 'section' || nextElementType === 'gate' || nextElementType === 'door')) {
        const postConfig = previousElement.userData?.fenceConfig?.elements?.post
        const postSpacing = postConfig?.spacing || 0.099
        // Odejmij spacing post od contactPoint (przesuń w lewo o spacing)
        const spacingOffset = new THREE.Vector3(-postSpacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Royal P50: post -> ${nextElementType}, odjęto spacing post ${postSpacing.toFixed(3)}m od rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        
        // 🚪 Dla gate/door 2x w Royal P50: zwiększ lekko odstęp od lewej
        // Zastosuj offset od lewej TYLKO dla zrotowanych gate/door 2x
        if ((nextElementType === 'gate' || nextElementType === 'door')) {
          // Pobierz widthMultiplier z kontekstu (będzie ustawiony w ElementToolbar)
          const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier
          // Sprawdź, czy poprzedni element jest zrotowany (jeśli tak, następny też będzie zrotowany)
          const isPreviousRotated = Math.abs(previousAbsoluteRotation) > 0.01
          console.log(`🔍 Royal P50: post -> ${nextElementType}, __nextElementWidthMultiplier=${nextWidthMultiplier}, isPreviousRotated=${isPreviousRotated}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
          // TYLKO dla 2x I TYLKO dla zrotowanych - jeśli nie jest ustawione, nie jest 2, lub nie jest zrotowany, nie dodawaj offsetu
          if (nextWidthMultiplier === 2 && isPreviousRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            // Dla 2x: większy offset od lewej (przesuń w prawo o 0.25x spacing)
            const leftOffsetMultiplier = -0.25
            const leftOffset = sectionSpacing * leftOffsetMultiplier
            const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
            leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(leftOffsetVector)
            console.log(`🚪 Royal P50: post -> ${nextElementType} (${nextWidthMultiplier}x), dodano offset od lewej ${leftOffset.toFixed(3)}m`)
            console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu offsetu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else {
            console.log(`🚪 Royal P50: post -> ${nextElementType} (${nextWidthMultiplier || 'nie ustawione'}x), NIE dodaję offsetu od lewej (tylko dla 2x)`)
          }
          // 🎯 Wyczyść __nextElementWidthMultiplier po użyciu, żeby nie było problemów z kolejnymi elementami
          ;(window as any).__nextElementWidthMultiplier = undefined
        }
      }
      
      // 🎯 Dla Royal P50: gdy dodajemy post/section po gate/door/section, dodaj spacing dla zrotowanych 2x
      // Dla section -> post: NIE dodawaj spacing (brak odstępu), ALE dla zrotowanych section 2x: dodaj spacing
      if ((previousElementType === 'gate' || previousElementType === 'door' || previousElementType === 'section') && (nextElementType === 'post' || nextElementType === 'section')) {
        const widthMultiplier = previousElement.userData?.widthMultiplier || 1
        const previousRotation = previousElement.userData?.absoluteRotation || 0
        const isRotated = Math.abs(previousRotation) > 0.01
        
          // 🚪 Dla gate/door 2x, 3x, 4x i 5x: dodaj spacing TYLKO dla zrotowanych (zwiększ odstęp po prawej)
          // Dla zrotowanych 2x: spacing (0.97x), dla zrotowanych 3x, 4x i 5x: spacing (0x)
          // Dla niezrotowanych: brak spacing (0x)
          if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && isRotated) {
        const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
        const sectionSpacing = sectionConfig?.spacing || 0.198
            let spacingMultiplier = 0
            if (widthMultiplier === 2) {
              spacingMultiplier = 0.97
            } else if (widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) {
              spacingMultiplier = 0
            }
          const spacingValue = sectionSpacing * spacingMultiplier
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
          const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
          console.log(`🚪 Royal P50: ${previousElementType} (${widthMultiplier}x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && !isRotated) {
          console.log(`🚪 Royal P50: ${previousElementType} (${widthMultiplier}x, NIE-ZROTOWANY) -> ${nextElementType}, NIE dodaję spacing (tylko dla zrotowanych)`)
        }
        // 🎯 Dla zrotowanych section 2x: dodaj spacing (zwiększ odstęp po prawej)
        else if (previousElementType === 'section' && widthMultiplier === 2 && isRotated) {
          const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
          const sectionSpacing = sectionConfig?.spacing || 0.198
          const spacingMultiplier = 1.02
          const spacingValue = sectionSpacing * spacingMultiplier
          // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
          const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
          spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(spacingOffset)
          console.log(`🎯 Royal P50: section (2x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
          console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        }
        // Dla innych przypadków: NIE dodawaj spacing (jak w S50)
      }
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Royal P50):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroP22SectionLike) {
      // 🎯 Dla Muro P22 gate/door: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // ⚠️ NIE modyfikować logiki dla section - tylko dla gate/door
      // Dla widthMultiplier >= 2: odejmij kompensację
      const muroP22ElementType = previousElementType === 'gate' ? 'gate' : 'door'
      console.log(`  - 🎯 Muro P22 ${muroP22ElementType}: obliczam rightEdge bezpośrednio (bez zapisanego)`)
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.074
      
      // Oblicz rightEdgeX tak samo jak dla section
      let rightEdgeX = prevPos.x + (previousElementWidth / 2)
      if (widthMultiplier >= 2) {
        // Różne kompensacje dla różnych widthMultiplier
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -1.0 // -0.074 dla 2x (dodaje zamiast odejmować)
        } else if (widthMultiplier === 3) {
          reduction = spacing * -1.0 // -0.074 dla 3x (dodaje, tak jak dla 2x)
        } else if (widthMultiplier === 4) {
          reduction = spacing * -1.0 // -0.074 dla 4x (dodaje, tak jak dla 2x/3x)
        } else if (widthMultiplier === 5) {
          reduction = spacing * -1.0 // -0.074 dla 5x (dodaje, tak jak dla innych)
        }
        rightEdgeX -= reduction
        console.log(`    - Muro P22 ${muroP22ElementType} ${widthMultiplier}x: odjęto ${reduction.toFixed(3)}m od rightEdge`)
      }
      
      // Oblicz rightEdgeOffset w lokalnych współrzędnych (przed rotacją)
      const rightEdgeOffsetX = rightEdgeX - prevPos.x
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      // Dla zrotowanych elementów: używaj rightEdgeOffset.z (prawidłowe przesunięcie po rotacji)
      // Dla niezrotowanych elementów: zachowaj wartość Z z poprzedniego elementu
      const isRotated = Math.abs(previousRotationRad) > 0.01
      contactPoint = new THREE.Vector3(
        prevPos.x + rightEdgeOffset.x,
        prevPos.y + rightEdgeOffset.y,
        isRotated ? prevPos.z + rightEdgeOffset.z : prevPos.z
      )
      
      // 🎯 Dla Muro P22: gdy dodajemy post po gate/door, dodaj spacing section od rightEdge
      if (nextElementType === 'post') {
        // Dla Muro Mix P22: dla zrotowanych 2x, 3x, 4x, 5x gate/door zmniejsz spacing po prawej
        const isMuroMixP22 = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix'
        const isRotated = Math.abs(previousAbsoluteRotation) > 0.01
        let spacingMultiplier = 1.0 // Domyślnie pełny spacing
        
        if (isMuroMixP22 && (widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && isRotated) {
          spacingMultiplier = 0.3 // Zmniejszony spacing dla zrotowanych 2x, 3x, 4x, 5x gate/door
          console.log(`🔍 Muro Mix P22: ${muroP22ElementType} (${widthMultiplier}x, ZROTOWANY ${previousAbsoluteRotation}°) -> post, używam spacingMultiplier=${spacingMultiplier}`)
        }
        
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
        const spacingValue = spacing * spacingMultiplier
        const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        // Dla zrotowanych elementów: używaj spacingOffset.z (prawidłowe przesunięcie po rotacji)
        // Dla niezrotowanych elementów: zachowaj wartość Z
        const isRotatedForSpacing = Math.abs(previousRotationRad) > 0.01
        contactPoint = new THREE.Vector3(
          contactPoint.x + spacingOffset.x,
          contactPoint.y + spacingOffset.y,
          isRotatedForSpacing ? contactPoint.z + spacingOffset.z : contactPoint.z
        )
        console.log(`🎯 Muro P22: ${muroP22ElementType} -> post, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      // 🎯 Dla Muro P22: gdy dodajemy gate/door po gate/door, dodaj małą korektę dla zrotowanych elementów
      if ((nextElementType === 'gate' || nextElementType === 'door')) {
        // Dodaj małą korektę (0.01m) żeby bramy nie nachodziły na siebie po rotacji
        const spacingOffset = new THREE.Vector3(spacing * 0.15, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        // Dla zrotowanych elementów: używaj spacingOffset.z (prawidłowe przesunięcie po rotacji)
        // Dla niezrotowanych elementów: zachowaj wartość Z
        const isRotatedForGateDoor = Math.abs(previousRotationRad) > 0.01
        contactPoint = new THREE.Vector3(
          contactPoint.x + spacingOffset.x,
          contactPoint.y + spacingOffset.y,
          isRotatedForGateDoor ? contactPoint.z + spacingOffset.z : contactPoint.z
        )
        console.log(`🎯 Muro P22: ${muroP22ElementType} -> ${nextElementType}, dodano małą korektę ${(spacing * 0.15).toFixed(3)}m dla rotacji`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po korekcie: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      // ⚠️ UWAGA: Logika dla post -> gate/door jest już obsłużona w bloku isMuroP22PostToGateDoor
      // Ten blok jest tylko dla gate/door -> gate/door lub gate/door -> section
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro P22 gate/door):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isMuroS22SectionLike) {
      // 🎯 Dla Muro S22 gate/door: zawsze oblicz bezpośrednio (nie używaj zapisanego rightEdge)
      // ⚠️ NIE modyfikować logiki dla section - tylko dla gate/door
      // Dla widthMultiplier >= 2: odejmij kompensację
      const muroS22ElementType = previousElementType === 'gate' ? 'gate' : 'door'
      console.log(`  - 🎯 Muro S22 ${muroS22ElementType}: obliczam rightEdge bezpośrednio (bez zapisanego)`)
      
      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.086
      
      // Oblicz rightEdgeX tak samo jak dla section
      let rightEdgeX = prevPos.x + (previousElementWidth / 2)
      if (widthMultiplier >= 2) {
        // Różne kompensacje dla różnych widthMultiplier (takie same jak dla section w Muro S22)
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * -0.9 // -0.077 dla 2x (dodaje zamiast odejmować)
        } else if (widthMultiplier === 3) {
          reduction = spacing * 0.0 // 0.0 dla 3x
        } else if (widthMultiplier === 4) {
          reduction = spacing * 0.9 // 0.077 dla 4x
        } else if (widthMultiplier === 5) {
          reduction = spacing * 1.8 // 0.155 dla 5x
        }
        rightEdgeX -= reduction
        console.log(`    - Muro S22 ${muroS22ElementType} ${widthMultiplier}x: odjęto ${reduction.toFixed(3)}m od rightEdge`)
      }
      
      // Oblicz rightEdgeOffset w lokalnych współrzędnych (przed rotacją)
      const rightEdgeOffsetX = rightEdgeX - prevPos.x
      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      // 🎯 Dla Muro S22: gdy dodajemy post po gate/door, dodaj spacing section od rightEdge
      if (nextElementType === 'post') {
        const isRotated = Math.abs(previousRotationRad) > 0.01
        const isRotatedAbsolute = Math.abs(previousAbsoluteRotation) > 0.01
        const isNotRotated = !isRotated && !isRotatedAbsolute
        
        // Dla niezrotowanych i zrotowanych gate/door 2x, 3x, 4x, 5x: użyj tych samych wartości
        let spacingMultiplier = 1.0
        if (widthMultiplier === 2) {
          spacingMultiplier = 0 // Brak dodatkowego spacing dla gate/door 2x
        } else if (widthMultiplier === 3) {
          spacingMultiplier = 0 // Brak dodatkowego spacing dla gate/door 3x
        } else if (widthMultiplier === 4) {
          spacingMultiplier = 1.6 // Spacing dla gate/door 4x
        } else if (widthMultiplier === 5) {
          spacingMultiplier = 2.4 // Spacing dla gate/door 5x
        }
        
        // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
        const spacingOffset = new THREE.Vector3(spacing * spacingMultiplier, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        // Dla niezrotowanych: zachowaj wartość Z
        contactPoint = new THREE.Vector3(
          contactPoint.x + spacingOffset.x,
          contactPoint.y + spacingOffset.y,
          isNotRotated ? contactPoint.z : contactPoint.z + spacingOffset.z
        )
        console.log(`🎯 Muro S22: ${muroS22ElementType} (${widthMultiplier}x, ${isNotRotated ? 'niezrotowany' : 'zrotowany'}) -> post, dodano spacing section ${(spacing * spacingMultiplier).toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      // 🎯 Dla Muro S22: gdy dodajemy gate/door po gate/door, odejmij spacing section od rightEdge
      // (tak jak w P22, ale dla S22 używamy section spacing 0.086)
      if ((previousElementType === 'gate' || previousElementType === 'door') && (nextElementType === 'gate' || nextElementType === 'door')) {
        // Odejmij spacing section od contactPoint (przesuń w lewo o spacing)
        const spacingOffset = new THREE.Vector3(-spacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 Muro S22: ${previousElementType} -> ${nextElementType}, odjęto spacing section ${spacing.toFixed(3)}m od rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
      }
      
      // ⚠️ UWAGA: Logika dla post -> gate/door jest już obsłużona w bloku isMuroS22PostToGateDoor
      // Ten blok jest tylko dla gate/door -> gate/door lub gate/door -> section
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Muro S22 gate/door):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (isSlim3DSectionLike) {
      // 🎯 Slim 3D (section/gate/door): oblicz rightEdge zawsze bezpośrednio z width i rotacji
      console.log('  - 🎯 Slim 3D section/gate/door: obliczam rightEdge bezpośrednio (bez zapisanego)')

      const prevPos = previousElement.position.clone()
      const widthMultiplier = previousElement.userData?.widthMultiplier || 1
      const fenceConfig = previousElement.userData?.fenceConfig
      const sectionConfig = fenceConfig?.elements?.section
      const spacing = sectionConfig?.spacing || 0.198

      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      console.log('    - widthMultiplier:', widthMultiplier, 'spacing:', spacing.toFixed(3))

      // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
      let rightEdgeOffsetX = previousElementWidth / 2
      if (widthMultiplier >= 2) {
        // Korekty dla różnych widthMultiplier w Slim 3D
        let reduction = 0
        if (widthMultiplier === 2) {
          reduction = spacing * 1.0 // korekta dla bramy (2x)
        } else if (widthMultiplier === 3) {
          reduction = spacing * 2 // korekta dla 3x
        } else if (widthMultiplier === 4) {
          reduction = spacing * 3.0 // korekta dla 4x
        } else if (widthMultiplier === 5) {
          reduction = spacing * 4.0 // korekta dla 5x
        }
        rightEdgeOffsetX -= reduction
        console.log('    - kompensacja dla', widthMultiplier + 'x:', reduction.toFixed(3) + 'm')
      }

      const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))

      contactPoint = prevPos.clone().add(rightEdgeOffset)

      console.log('    - rightEdgeOffset (Slim 3D):', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
      console.log('    - contactPoint (Slim 3D):', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    } else if (previousElement.userData?.rightEdge) {
      // 🎯 Dla Muro Mix P22/P38/S22/S38 post -> section: oblicz rightEdge bezpośrednio PRZED użyciem zapisanego rightEdge
      const isMuroMixP22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22'
      const isMuroMixP38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38'
      const isMuroMixS22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22'
      const isMuroMixS38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s38'
      
      if ((isMuroMixP22ForSpacing || isMuroMixP38ForSpacing || isMuroMixS22ForSpacing || isMuroMixS38ForSpacing) && previousElementType === 'post' && nextElementType === 'section') {
        // Dla section po post: zawsze używaj rightEdge z userData (jest poprawnie obliczony w updateElementRotation)
        // i odejmij spacing w odpowiednim układzie współrzędnych
        // Uwaga: section's rightEdge dla widthMultiplier=3 nie odejmuje spacing (reduction = 0.0),
        // więc musimy odjąć spacing od post's rightEdge, żeby sekcja była poprawnie pozycjonowana
        let fenceType = 'P22'
        if (isMuroMixP22ForSpacing) fenceType = 'P22'
        else if (isMuroMixP38ForSpacing) fenceType = 'P38'
        else if (isMuroMixS22ForSpacing) fenceType = 'S22'
        else if (isMuroMixS38ForSpacing) fenceType = 'S38'
        const fenceConfig = previousElement.userData?.fenceConfig
        const postConfig = fenceConfig?.elements?.post
        const postSpacing = postConfig?.spacing || 0.074
        const previousRotation = previousElement.userData?.absoluteRotation || 0
        const previousRotationRad = (previousRotation * Math.PI) / 180
        const isRotated = Math.abs(previousRotation) > 0.01
        
        // 🎯 KLUCZOWE: Dla zrotowanych postów, rightEdge z userData może mieć błąd kumulatywny w osi Z
        // Oblicz rightEdge bezpośrednio z pozycji posta, żeby uniknąć kumulatywnych przesunięć
        if (isRotated) {
          // Dla zrotowanych: oblicz rightEdge bezpośrednio z pozycji posta
          const prevPos = previousElement.position.clone()
          let rightEdgeOffsetX = previousElementWidth / 2
          
          // Odejmij spacing post od rightEdge (przesuń w lewo o spacing), żeby sekcja była bezpośrednio po słupku
          // Dla różnych typów: użyj różnych mnożników
          let spacingMultiplier = 1.7
          if (fenceType === 'S22') {
            spacingMultiplier = 1.3
          } else if (fenceType === 'S38') {
            spacingMultiplier = 1.7
          } else if (fenceType === 'P22' || fenceType === 'P38') {
            spacingMultiplier = 1.7
          }
          rightEdgeOffsetX -= postSpacing * spacingMultiplier
          
          // Obróć offset zgodnie z rotacją posta
          const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
          rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          
          contactPoint = prevPos.clone().add(rightEdgeOffset)
          
          console.log(`🎯 Muro Mix ${fenceType}: post -> section (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (unikanie kumulatywnego błędu w Z)`)
          console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
          console.log(`  - previousElementWidth: ${previousElementWidth.toFixed(6)}`)
          console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
          console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else {
          // Dla nie-zrotowanych: użyj rightEdge z userData i odejmij spacing
          contactPoint = previousElement.userData.rightEdge.clone()
          
          // Odejmij spacing post od contactPoint (przesuń w lewo o spacing)
          // Dla różnych typów: użyj różnych mnożników
          // Dla nie-zrotowanych (rotation = 0): spacingOffset będzie w osi X, więc nie będzie przesunięcia w Z
          let spacingMultiplier = 1.7
          if (fenceType === 'S22') {
            spacingMultiplier = 1.3
          } else if (fenceType === 'S38') {
            spacingMultiplier = 1.7
          } else if (fenceType === 'P22' || fenceType === 'P38') {
            spacingMultiplier = 1.7
          }
          const spacingOffset = new THREE.Vector3(-postSpacing * spacingMultiplier, 0, 0)
          contactPoint.add(spacingOffset)
          
          console.log(`🎯 Muro Mix ${fenceType}: post -> section (NIE-ZROTOWANY), używam rightEdge z userData i odejmuję spacing post (2.0x)`)
          console.log(`  - rightEdge z userData: X=${previousElement.userData.rightEdge.x.toFixed(6)}, Z=${previousElement.userData.rightEdge.z.toFixed(6)}`)
          console.log(`  - postSpacing: ${postSpacing.toFixed(6)}`)
          console.log(`  - spacingOffset (2.0x, bez rotacji): X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        }
      } else {
        // Użyj zapisanej prawej krawędzi (dla innych ogrodzeń)
        contactPoint = previousElement.userData.rightEdge.clone()
        console.log('  - ✅ używam zapisanego rightEdge:', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
        
        // 🚪 Dla gate/door 2x w Royal Mix S50: zwiększ lekko odstęp od lewej
        // Gdy dodajemy gate/door 2x PO post, zwiększ odstęp od lewej (TYLKO dla zrotowanych 2x)
        const isRoyalMixS50ForLeftOffset = previousElement.userData?.originalFenceConfigId === 'royal-mix' && previousElement.userData?.fenceConfig?.id === 'royal_s50'
        if (isRoyalMixS50ForLeftOffset && previousElementType === 'post' && (nextElementType === 'gate' || nextElementType === 'door')) {
          // Pobierz widthMultiplier z kontekstu (będzie ustawiony w ElementToolbar)
          const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier
          // Sprawdź, czy poprzedni element jest zrotowany (jeśli tak, następny też będzie zrotowany)
          const previousAbsoluteRotation = previousElement.userData?.absoluteRotation || 0
          const isPreviousRotated = Math.abs(previousAbsoluteRotation) > 0.01
          console.log(`🔍 Royal Mix S50: post -> ${nextElementType}, __nextElementWidthMultiplier=${nextWidthMultiplier}, isPreviousRotated=${isPreviousRotated}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
          // TYLKO dla 2x I TYLKO dla zrotowanych - jeśli nie jest ustawione, nie jest 2, lub nie jest zrotowany, nie dodawaj offsetu
          if (nextWidthMultiplier === 2 && isPreviousRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            // Dla 2x: większy offset od lewej (przesuń w prawo o 0.25x spacing)
            const leftOffsetMultiplier = -0.25
            const leftOffset = sectionSpacing * leftOffsetMultiplier
            const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
            leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(leftOffsetVector)
            console.log(`🚪 Royal Mix S50: post -> ${nextElementType} (${nextWidthMultiplier}x), dodano offset od lewej ${leftOffset.toFixed(3)}m`)
            console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu offsetu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else {
            console.log(`🚪 Royal Mix S50: post -> ${nextElementType} (${nextWidthMultiplier || 'nie ustawione'}x), NIE dodaję offsetu od lewej (tylko dla zrotowanych 2x)`)
          }
          // 🎯 Wyczyść __nextElementWidthMultiplier po użyciu, żeby nie było problemów z kolejnymi elementami
          ;(window as any).__nextElementWidthMultiplier = undefined
        }
        
        // 🚪 Dla gate/door 2x w Royal Mix P50: zwiększ lekko odstęp od lewej
        // Gdy dodajemy gate/door 2x PO post, zwiększ odstęp od lewej (TYLKO dla zrotowanych 2x)
        const isRoyalMixP50ForLeftOffset = previousElement.userData?.originalFenceConfigId === 'royal-mix' && previousElement.userData?.fenceConfig?.id === 'royal_p50'
        if (isRoyalMixP50ForLeftOffset && previousElementType === 'post' && (nextElementType === 'gate' || nextElementType === 'door')) {
          // Pobierz widthMultiplier z kontekstu (będzie ustawiony w ElementToolbar)
          const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier
          // Sprawdź, czy poprzedni element jest zrotowany (jeśli tak, następny też będzie zrotowany)
          const previousAbsoluteRotation = previousElement.userData?.absoluteRotation || 0
          const isPreviousRotated = Math.abs(previousAbsoluteRotation) > 0.01
          console.log(`🔍 Royal Mix P50: post -> ${nextElementType}, __nextElementWidthMultiplier=${nextWidthMultiplier}, isPreviousRotated=${isPreviousRotated}, previousAbsoluteRotation=${previousAbsoluteRotation}`)
          // TYLKO dla 2x I TYLKO dla zrotowanych - jeśli nie jest ustawione, nie jest 2, lub nie jest zrotowany, nie dodawaj offsetu
          if (nextWidthMultiplier === 2 && isPreviousRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            // Dla 2x: większy offset od lewej (przesuń w prawo o 0.25x spacing)
            const leftOffsetMultiplier = -0.25
            const leftOffset = sectionSpacing * leftOffsetMultiplier
            const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
            leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(leftOffsetVector)
            console.log(`🚪 Royal Mix P50: post -> ${nextElementType} (${nextWidthMultiplier}x), dodano offset od lewej ${leftOffset.toFixed(3)}m`)
            console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu offsetu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else {
            console.log(`🚪 Royal Mix P50: post -> ${nextElementType} (${nextWidthMultiplier || 'nie ustawione'}x), NIE dodaję offsetu od lewej (tylko dla 2x)`)
          }
          // 🎯 Wyczyść __nextElementWidthMultiplier po użyciu, żeby nie było problemów z kolejnymi elementami
          ;(window as any).__nextElementWidthMultiplier = undefined
        }
        
        // 🎯 Dla Royal Mix S50: gdy dodajemy post/section po gate/door/section, dodaj spacing dla zrotowanych 2x
        // Dla section -> post: NIE dodawaj spacing (brak odstępu), ALE dla zrotowanych section 2x: dodaj spacing
        const isRoyalMixS50ForSpacing = previousElement.userData?.originalFenceConfigId === 'royal-mix' && previousElement.userData?.fenceConfig?.id === 'royal_s50'
        if (isRoyalMixS50ForSpacing && (previousElementType === 'gate' || previousElementType === 'door' || previousElementType === 'section') && (nextElementType === 'post' || nextElementType === 'section')) {
          const widthMultiplier = previousElement.userData?.widthMultiplier || 1
          const previousRotation = previousElement.userData?.absoluteRotation || 0
          const isRotated = Math.abs(previousRotation) > 0.01
          
          // 🚪 Dla gate/door 2x, 3x, 4x i 5x: dodaj spacing TYLKO dla zrotowanych (zwiększ odstęp po prawej)
          // Dla zrotowanych 2x: spacing (0.97x), dla zrotowanych 3x, 4x i 5x: spacing (0x)
          // Dla niezrotowanych: brak spacing (0x)
          if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && isRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            let spacingMultiplier = 0
            if (widthMultiplier === 2) {
              spacingMultiplier = 0.97
            } else if (widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) {
              spacingMultiplier = 0
            }
            const spacingValue = sectionSpacing * spacingMultiplier
            // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
            const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
            spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(spacingOffset)
            console.log(`🚪 Royal Mix S50: ${previousElementType} (${widthMultiplier}x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
            console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && !isRotated) {
            console.log(`🚪 Royal Mix S50: ${previousElementType} (${widthMultiplier}x, NIE-ZROTOWANY) -> ${nextElementType}, NIE dodaję spacing (tylko dla zrotowanych)`)
          }
          // Dla section: NIE dodawaj spacing (brak odstępu) - zarówno dla zrotowanych jak i niezrotowanych
          // Dla innych przypadków: NIE dodawaj spacing (jak w S50)
        }
        
        // 🎯 Dla Royal Mix P50: gdy dodajemy post/section po gate/door/section, dodaj spacing dla zrotowanych 2x
        // Dla section -> post: NIE dodawaj spacing (brak odstępu), ALE dla zrotowanych section 2x: dodaj spacing
        const isRoyalMixP50ForSpacing = previousElement.userData?.originalFenceConfigId === 'royal-mix' && previousElement.userData?.fenceConfig?.id === 'royal_p50'
        if (isRoyalMixP50ForSpacing && (previousElementType === 'gate' || previousElementType === 'door' || previousElementType === 'section') && (nextElementType === 'post' || nextElementType === 'section')) {
          const widthMultiplier = previousElement.userData?.widthMultiplier || 1
          const previousRotation = previousElement.userData?.absoluteRotation || 0
          const isRotated = Math.abs(previousRotation) > 0.01
          
          // 🚪 Dla gate/door 2x, 3x, 4x i 5x: dodaj spacing TYLKO dla zrotowanych (zwiększ odstęp po prawej)
          // Dla zrotowanych 2x: spacing (0.97x), dla zrotowanych 3x, 4x i 5x: spacing (0x)
          // Dla niezrotowanych: brak spacing (0x)
          if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && isRotated) {
          const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
          const sectionSpacing = sectionConfig?.spacing || 0.198
            let spacingMultiplier = 0
            if (widthMultiplier === 2) {
              spacingMultiplier = 0.97
            } else if (widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) {
              spacingMultiplier = 0
            }
            const spacingValue = sectionSpacing * spacingMultiplier
          // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
            const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
          spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(spacingOffset)
            console.log(`🚪 Royal Mix P50: ${previousElementType} (${widthMultiplier}x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
          console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          } else if ((widthMultiplier === 2 || widthMultiplier === 3 || widthMultiplier === 4 || widthMultiplier === 5) && (previousElementType === 'gate' || previousElementType === 'door') && !isRotated) {
            console.log(`🚪 Royal Mix P50: ${previousElementType} (${widthMultiplier}x, NIE-ZROTOWANY) -> ${nextElementType}, NIE dodaję spacing (tylko dla zrotowanych)`)
          }
          // 🎯 Dla zrotowanych section 2x: dodaj spacing (zwiększ odstęp po prawej)
          else if (previousElementType === 'section' && widthMultiplier === 2 && isRotated) {
            const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
            const sectionSpacing = sectionConfig?.spacing || 0.198
            const spacingMultiplier = 1.02
            const spacingValue = sectionSpacing * spacingMultiplier
            // Dodaj spacing section do contactPoint (przesuń w prawo o spacing)
            const spacingOffset = new THREE.Vector3(spacingValue, 0, 0)
            spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            contactPoint.add(spacingOffset)
            console.log(`🎯 Royal Mix P50: section (2x, ZROTOWANY ${previousRotation}°) -> ${nextElementType}, dodano spacing section ${spacingValue.toFixed(3)}m (${spacingMultiplier}x) do rightEdge`)
            console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
            console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          }
          // Dla innych przypadków: NIE dodawaj spacing (jak w S50)
        }
        
        // 🎯 Dla Muro Mix P22/P38/S22/S38: wszystkie przypadki spacing (takie same jak dla normalnego Muro P22/P38/S22/S38)
        // Definiuj zmienne dla Muro Mix spacing (dla gate/door -> post)
        const isMuroMixP22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22'
        const isMuroMixP38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38'
        const isMuroMixS22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22'
        const isMuroMixS38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s38'
        
        console.log(`🔍 DEBUG Muro Mix P22/P38/S22/S38 spacing: isMuroMixP22ForSpacing=${isMuroMixP22ForSpacing}, isMuroMixP38ForSpacing=${isMuroMixP38ForSpacing}, isMuroMixS22ForSpacing=${isMuroMixS22ForSpacing}, isMuroMixS38ForSpacing=${isMuroMixS38ForSpacing}, originalFenceConfigId=${previousElement.userData?.originalFenceConfigId}, fenceConfig.id=${previousElement.userData?.fenceConfig?.id}, previousElementType=${previousElementType}, nextElementType=${nextElementType}`)
        
        if (isMuroMixP22ForSpacing || isMuroMixP38ForSpacing || isMuroMixS22ForSpacing || isMuroMixS38ForSpacing) {
          let fenceType = 'P22'
          if (isMuroMixP22ForSpacing) fenceType = 'P22'
          else if (isMuroMixP38ForSpacing) fenceType = 'P38'
          else if (isMuroMixS22ForSpacing) fenceType = 'S22'
          else if (isMuroMixS38ForSpacing) fenceType = 'S38'
          const fenceConfig = previousElement.userData?.fenceConfig
          const sectionConfig = fenceConfig?.elements?.section
          const postConfig = fenceConfig?.elements?.post
          const sectionSpacing = sectionConfig?.spacing || 0.074
          const postSpacing = postConfig?.spacing || 0.074
          const previousRotation = previousElement.userData?.absoluteRotation || 0
          const previousRotationRad = (previousRotation * Math.PI) / 180
          
          console.log(`🔍 DEBUG Muro Mix ${fenceType} spacing: sectionSpacing=${sectionSpacing}, postSpacing=${postSpacing}, contactPoint przed: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          
          // 🎯 Przypadek 1: section/gate/door -> post
          // Dla zrotowanych elementów: dodaj spacing section, żeby słupek nie nachodził na section
          // ⚠️ Dla P38: użyj ujemnego spacingMultiplier, żeby zmniejszyć odstęp (ma inną geometrię niż P22)
          if ((previousElementType === 'section' || previousElementType === 'gate' || previousElementType === 'door') && nextElementType === 'post') {
            console.log(`🔍 DEBUG Muro Mix ${fenceType}: Przypadek 1 - ${previousElementType} -> ${nextElementType}`)
            const isRotated = Math.abs(previousRotation) > 0.01
            
            if (isRotated) {
              // Dla zrotowanych: dodaj spacing section do contactPoint
              // Dla S22: użyj mniejszego mnożnika (1.3), żeby zmniejszyć odstęp
              // Dla P38: użyj ujemnego mnożnika, różnie dla różnych multipliers
              // Dla P22: dla zrotowanego 2x gate/door zmniejsz spacing
              // Dla innych typów: użyj 1.9
              let spacingMultiplier = 1.9
              if (fenceType === 'S22') {
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                // Dla zrotowanych gate/door 2x, 3x, 4x, 5x: użyj tych samych wartości co dla niezrotowanych
                if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 2) {
                  spacingMultiplier = 0 // Brak dodatkowego spacing dla zrotowanych gate/door 2x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 3) {
                  spacingMultiplier = 0 // Brak dodatkowego spacing dla zrotowanych gate/door 3x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 4) {
                  spacingMultiplier = 1.6 // Spacing dla zrotowanych gate/door 4x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 5) {
                  spacingMultiplier = 2.4 // Spacing dla zrotowanych gate/door 5x
                } else {
                  spacingMultiplier = 1.3 // Domyślnie dla S22
                }
              } else if (fenceType === 'P22') {
                // Dla Muro Mix P22: dla zrotowanego 2x gate/door zmniejsz spacing po prawej
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                console.log(`🔍 DEBUG Muro Mix P22 spacing: previousElementType=${previousElementType}, widthMultiplier=${widthMultiplier}, isRotated=${isRotated}`)
                if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 2) {
                  spacingMultiplier = 0.5 // Jeszcze bardziej zmniejszony spacing dla zrotowanego 2x gate/door
                  console.log(`✅ Muro Mix P22: Używam spacingMultiplier=0.5 dla zrotowanego 2x ${previousElementType}`)
                } else {
                  spacingMultiplier = 1.9 // Domyślnie dla P22
                  console.log(`⚠️ Muro Mix P22: Używam spacingMultiplier=1.9 (domyślnie) - previousElementType=${previousElementType}, widthMultiplier=${widthMultiplier}`)
                }
              } else if (fenceType === 'P38') {
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                if (widthMultiplier === 2) {
                  spacingMultiplier = -2.7 // UJEMNA wartość dla 2x (200mm - mniejszy odstęp)
                } else if (widthMultiplier === 3) {
                  spacingMultiplier = 2.0 // DODATNIA wartość dla zrotowanych 3x (148mm - większy odstęp)
                } else if (widthMultiplier === 4) {
                  spacingMultiplier = 2.0 // DODATNIA wartość dla zrotowanych 4x (148mm - jeszcze większy odstęp)
                } else if (widthMultiplier === 5) {
                  spacingMultiplier = 2.18 // DODATNIA wartość dla zrotowanych 5x (161mm - największy odstęp)
                } else {
                  spacingMultiplier = -2.18 // Domyślnie dla P38
                }
              }
              const spacingOffset = new THREE.Vector3(sectionSpacing * spacingMultiplier, 0, 0)
              spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              contactPoint.add(spacingOffset)
              console.log(`🎯 Muro Mix ${fenceType}: ${previousElementType} -> post (ZROTOWANY ${previousRotation}°), dodano spacing section ${(sectionSpacing * spacingMultiplier).toFixed(3)}m do rightEdge`)
              console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else {
              // Dla nie-zrotowanych: dodaj spacing section do contactPoint
              // Dla S22: dla niezrotowanych 3x, 4x, 5x użyj większego mnożnika, żeby zwiększyć odstęp
              // Dla P38: dla niezrotowanych 3x, 4x, 5x użyj dodatniego mnożnika, żeby zwiększyć odstęp
              // Dla innych typów: użyj 1.9
              let spacingMultiplier = 1.9
              if (fenceType === 'S22') {
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                console.log(`🔍 DEBUG Muro Mix S22 spacing: previousElementType=${previousElementType}, widthMultiplier=${widthMultiplier}, isRotated=${isRotated}`)
                // Dla niezrotowanych gate/door 2x: zmniejsz spacing po prawej
                // Dla niezrotowanych gate/door 3x, 4x: zwiększ spacing po prawej
                // Dla niezrotowanych 3x, 4x, 5x: zwiększ spacing, żeby słupek nie nachodził
                if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 2) {
                  spacingMultiplier = 0.5 // Zmniejszony spacing dla niezrotowanych gate/door 2x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 3) {
                  spacingMultiplier = 1.3 // Zwiększony spacing dla niezrotowanych gate/door 3x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 4) {
                  spacingMultiplier = 2.2 // Zwiększony spacing dla niezrotowanych gate/door 4x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 5) {
                  spacingMultiplier = 3.0 // Zwiększony spacing dla niezrotowanych gate/door 5x
                } else if (widthMultiplier === 3) {
                  spacingMultiplier = 1.5 // Zwiększony spacing dla niezrotowanych section 3x
                } else if (widthMultiplier === 4) {
                  spacingMultiplier = 2.3 // Zwiększony spacing dla niezrotowanych section 4x
                } else if (widthMultiplier === 5) {
                  spacingMultiplier = 3.1 // Zwiększony spacing dla niezrotowanych 5x
                } else {
                  spacingMultiplier = 1.3 // Domyślnie dla S22
                }
                console.log(`✅ Muro Mix S22: Używam spacingMultiplier=${spacingMultiplier} dla niezrotowanej ${widthMultiplier}x ${previousElementType}`)
              } else if (fenceType === 'P38') {
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                if (widthMultiplier === 2) {
                  spacingMultiplier = -2.7 // UJEMNA wartość dla 2x (200mm - mniejszy odstęp)
                } else if (widthMultiplier === 3) {
                  spacingMultiplier = 2.0 // DODATNIA wartość dla niezrotowanych 3x (148mm - większy odstęp)
                } else if (widthMultiplier === 4) {
                  spacingMultiplier = 3.0 // DODATNIA wartość dla niezrotowanych 4x (222mm - jeszcze większy odstęp)
                } else if (widthMultiplier === 5) {
                  spacingMultiplier = 4.0 // DODATNIA wartość dla niezrotowanych 5x (296mm - największy odstęp)
                } else {
                  spacingMultiplier = -2.18 // Domyślnie dla P38
                }
              } else if (fenceType === 'S38') {
                const widthMultiplier = previousElement.userData?.widthMultiplier || 1
                // Dla niezrotowanych gate/door 2x: zwiększ spacing po prawej
                if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 2) {
                  spacingMultiplier = 3.1 // Zwiększony spacing dla niezrotowanych gate/door 2x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 3) {
                  spacingMultiplier = 11.5 // Zwiększony spacing dla niezrotowanych gate/door 3x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 4) {
                  spacingMultiplier = 8.8 // Zwiększony spacing dla niezrotowanych gate/door 4x
                } else if ((previousElementType === 'gate' || previousElementType === 'door') && widthMultiplier === 5) {
                  spacingMultiplier = 11.5 // Zwiększony spacing dla niezrotowanych gate/door 5x
                } else if (widthMultiplier === 4) {
                  spacingMultiplier = 3.0 // Spacing dla niezrotowanych section 4x
                } else if (widthMultiplier === 5) {
                  spacingMultiplier = 4.0 // Spacing dla niezrotowanych section 5x
                } else {
                  spacingMultiplier = 1.9 // Domyślnie dla S38
                }
              }
              const spacingOffset = new THREE.Vector3(sectionSpacing * spacingMultiplier, 0, 0)
              // Dla nie-zrotowanych spacingOffset będzie w osi X, więc nie będzie przesunięcia w Z
              contactPoint.add(spacingOffset)
              console.log(`🎯 Muro Mix ${fenceType}: ${previousElementType} -> post (NIE-ZROTOWANY), dodano spacing section ${(sectionSpacing * spacingMultiplier).toFixed(3)}m do rightEdge`)
              console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint po dodaniu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            }
          }
          
          // 🎯 Przypadek 2: section -> section (NIE dodawaj spacing - sekcje powinny być bezpośrednio obok siebie)
          // Dla Muro Mix sekcje powinny być bezpośrednio obok siebie bez odstępu
          if (previousElementType === 'section' && nextElementType === 'section') {
            const isRotated = Math.abs(previousRotation) > 0.01
            
            if (isRotated) {
              // Dla zrotowanych sekcji: oblicz rightEdge bezpośrednio z pozycji sekcji
              // To zapobiega kumulatywnym błędom w osi Z, ponieważ nie używamy rightEdge z userData
              const prevPos = previousElement.position.clone()
              const widthMultiplier = previousElement.userData?.widthMultiplier || 1
              
              // 🎯 Oblicz rightEdge z kompensacją dla widthMultiplier >= 2
              // NIE dodawaj spacing - sekcje powinny być bezpośrednio obok siebie
              let rightEdgeOffsetX = previousElementWidth / 2
              if (widthMultiplier >= 2) {
                // Różne kompensacje dla różnych widthMultiplier i różnych typów
                let reduction = 0
                if (fenceType === 'P22' || fenceType === 'P38') {
                  // Dla P22/P38: takie same kompensacje
                  if (widthMultiplier === 2) {
                    reduction = sectionSpacing * -1.0 // -0.074 dla 2x (dodaje zamiast odejmować)
                  } else if (widthMultiplier === 3) {
                    reduction = sectionSpacing * 0.0 // 0.0 dla 3x
                  } else if (widthMultiplier === 4) {
                    reduction = sectionSpacing * 1.0 // 0.074 dla 4x
                  } else if (widthMultiplier === 5) {
                    reduction = sectionSpacing * 2.0 // 0.148 dla 5x
                  }
                } else if (fenceType === 'S22' || fenceType === 'S38') {
                  // Dla S22/S38: inne kompensacje
                  if (widthMultiplier === 2) {
                    reduction = sectionSpacing * -0.9 // -0.067 dla 2x (dodaje zamiast odejmować)
                  } else if (widthMultiplier === 3) {
                    reduction = sectionSpacing * 0.0 // 0.0 dla 3x
                  } else if (widthMultiplier === 4) {
                    reduction = sectionSpacing * 0.9 // 0.067 dla 4x
                  } else if (widthMultiplier === 5) {
                    reduction = sectionSpacing * 1.8 // 0.133 dla 5x
                  }
                }
                rightEdgeOffsetX -= reduction
              }
              
              // Obróć offset zgodnie z rotacją sekcji (BEZ spacing - sekcje bezpośrednio obok siebie)
              const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
              rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              
              contactPoint = prevPos.clone().add(rightEdgeOffset)
              
              // NIE dodawaj spacing - sekcje powinny być bezpośrednio obok siebie
              
              console.log(`🎯 Muro Mix ${fenceType}: section -> section (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji sekcji (BEZ spacing)`)
              console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
              console.log(`  - widthMultiplier: ${widthMultiplier}, previousElementWidth: ${previousElementWidth.toFixed(6)}`)
              console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
              console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else {
              // Dla nie-zrotowanych sekcji: użyj rightEdge z userData (BEZ dodawania spacing)
              // contactPoint już jest ustawiony na rightEdge z userData, więc nie trzeba nic dodawać
              console.log(`🎯 Muro Mix ${fenceType}: section -> section (NIE-ZROTOWANY), używam rightEdge z userData (BEZ spacing)`)
              console.log(`  - rightEdge z userData: X=${previousElement.userData.rightEdge.x.toFixed(6)}, Z=${previousElement.userData.rightEdge.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            }
          }
          
          // 🎯 Przypadek 3: post -> post (dla zrotowanych P22: oblicz rightEdge bezpośrednio z pozycji, dla nie-zrotowanych: użyj rightEdge z userData)
          if (previousElementType === 'post' && nextElementType === 'post') {
            const isRotated = Math.abs(previousRotation) > 0.01
            
            if (isRotated && fenceType === 'P22') {
              // Dla zrotowanego P22: oblicz rightEdge bezpośrednio z pozycji posta
              // P22: spacing = 0.074, szerokość posta = 0.148
              // P38: spacing = 0.074, szerokość posta = 0.148 (taka sama jak P22)
              const prevPos = previousElement.position.clone()
              let rightEdgeOffsetX = previousElementWidth / 2
              
              // Sprawdź szerokość następnego elementu, żeby rozróżnić P22 od P38/S22/S38
              const nextElementWidth = elementWidth || previousElementWidth
              const isNextP22 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p22' // P22 ma szerokość ~0.148
              const isNextP38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p38' // P38 ma szerokość ~0.148 (taka sama jak P22)
              const isNextS38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 's38' // S38 ma szerokość ~0.148 (taka sama jak P22/P38)
              const isNextS22 = Math.abs(nextElementWidth - 0.184) < 0.02 // S22 ma szerokość ~0.184
              const isPrevP22 = Math.abs(previousElementWidth - 0.148) < 0.02 // Poprzedni to P22
              
              console.log(`🔍 DEBUG P22 spacing: nextElementWidth=${nextElementWidth.toFixed(6)}, previousElementWidth=${previousElementWidth.toFixed(6)}, elementWidth=${elementWidth?.toFixed(6) || 'undefined'}, selectedVariant=${selectedVariant}, isNextP22=${isNextP22}, isNextP38=${isNextP38}, isNextS38=${isNextS38}, isNextS22=${isNextS22}, isPrevP22=${isPrevP22}, postSpacing=${postSpacing.toFixed(6)}`)
              console.log(`🔍 DEBUG P22 spacing WARUNKI: isPrevP22=${isPrevP22}, isNextP38=${isNextP38}, isNextP22=${isNextP22}, isNextS22=${isNextS22}, isNextS38=${isNextS38}, Math.abs(nextElementWidth - previousElementWidth) < 0.01=${Math.abs(nextElementWidth - previousElementWidth) < 0.01}`)
              
              // 🎯 W Muro Mix: najpierw sprawdź, czy następny to S22 (używając szerokości)
              // Potem sprawdź, czy następny to S38 (używając selectedVariant)
              // Potem sprawdź, czy następny to P38 (używając selectedVariant)
              // Potem sprawdź, czy następny to P22
              // Na końcu sprawdź, czy szerokości są takie same
              if (isPrevP22 && isNextS22) {
                // P22 -> S22: użyj 0.5 (odejmij spacing, żeby jeszcze bardziej zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.5
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> S22)`)
              } else if (isPrevP22 && isNextS38) {
                // P22 -> S38: dodaj spacing (0.1), żeby zwiększyć odstęp
                rightEdgeOffsetX += postSpacing * 0.1
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> S38)`)
              } else if (isPrevP22 && isNextP38) {
                // P22 -> P38: użyj 0 (bez kompensacji)
                rightEdgeOffsetX -= postSpacing * 0
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> P38)`)
              } else if ((isPrevP22 && isNextP22) || (Math.abs(nextElementWidth - previousElementWidth) < 0.01 && !isNextP38 && !isNextS22 && !isNextS38)) {
                // P22 -> P22: użyj 0.3 (odejmij spacing)
                rightEdgeOffsetX -= postSpacing * 0.3
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> P22)`)
              } else {
                // Domyślnie dla P22 -> P22: użyj 0.3 (jeśli poprzedni to P22)
                if (isPrevP22) {
                  rightEdgeOffsetX -= postSpacing * 0.3
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> P22, domyślne)`)
                } else {
                  rightEdgeOffsetX -= postSpacing * 0
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P22 -> P38, domyślne)`)
                }
              }
              
              // Obróć offset zgodnie z rotacją posta
              const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
              rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              
              contactPoint = prevPos.clone().add(rightEdgeOffset)
              
              console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
              console.log(`  - previousElementWidth: ${previousElementWidth.toFixed(6)}`)
              console.log(`  - nextElementWidth: ${nextElementWidth.toFixed(6)}`)
              console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
              console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else if (isRotated && fenceType === 'P38') {
              // Dla zrotowanego P38: oblicz rightEdge bezpośrednio z pozycji posta
              // P38: spacing = 0.074, szerokość posta = 0.148
              // S22: spacing = 0.092, szerokość posta = 0.184
              const prevPos = previousElement.position.clone()
              let rightEdgeOffsetX = previousElementWidth / 2
              
              // Sprawdź szerokość następnego elementu, żeby rozróżnić P38 od S22/P22
              const nextElementWidth = elementWidth || previousElementWidth
              const isNextP38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p38' // P38 ma szerokość ~0.148
              const isNextP22 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p22' // P22 ma szerokość ~0.148 (taka sama jak P38)
              const isNextS22 = Math.abs(nextElementWidth - 0.184) < 0.02 // S22 ma szerokość ~0.184
              const isPrevP38 = Math.abs(previousElementWidth - 0.148) < 0.02 // Poprzedni to P38
              
              console.log(`🔍 DEBUG P38 spacing: nextElementWidth=${nextElementWidth.toFixed(6)}, previousElementWidth=${previousElementWidth.toFixed(6)}, elementWidth=${elementWidth?.toFixed(6) || 'undefined'}, selectedVariant=${selectedVariant}, isNextP38=${isNextP38}, isNextP22=${isNextP22}, isNextS22=${isNextS22}, isPrevP38=${isPrevP38}, postSpacing=${postSpacing.toFixed(6)}`)
              
              // 🎯 W Muro Mix: jeśli poprzedni to P38 i następny to S22, zmniejsz odstęp
              // Jeśli następny to P22, zmniejsz odstęp (0.3)
              if (isPrevP38 && isNextS22) {
                // P38 -> S22: użyj 0.45 (odejmij spacing, żeby bardzo lekko zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.45
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P38 -> S22)`)
              } else if (isPrevP38 && isNextP22) {
                // P38 -> P22: użyj 0.2 (odejmij spacing, żeby lekko zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.2
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P38 -> P22)`)
              } else if (isNextP38 && Math.abs(nextElementWidth - previousElementWidth) < 0.01) {
                // P38 -> P38: użyj 0 (bez kompensacji)
                rightEdgeOffsetX -= postSpacing * 0
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P38 -> P38)`)
              } else {
                // Domyślnie dla P38 -> P38: użyj 0 (jeśli poprzedni to P38)
                if (isPrevP38) {
                  rightEdgeOffsetX -= postSpacing * 0
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P38 -> P38, domyślne)`)
                } else {
                  // Dla innych przypadków: użyj domyślnej wartości
                  rightEdgeOffsetX -= postSpacing * 0.3
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (P38 -> inne, domyślne)`)
                }
              }
              
              // Obróć offset zgodnie z rotacją posta
              const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
              rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              
              contactPoint = prevPos.clone().add(rightEdgeOffset)
              
              console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
              console.log(`  - previousElementWidth: ${previousElementWidth.toFixed(6)}`)
              console.log(`  - nextElementWidth: ${nextElementWidth.toFixed(6)}`)
              console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
              console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else if (isRotated && fenceType === 'S22') {
              // Dla zrotowanego S22: oblicz rightEdge bezpośrednio z pozycji posta
              // S22: spacing = 0.092, szerokość posta = 0.184
              // S38: spacing = 0.074, szerokość posta = 0.148
              const prevPos = previousElement.position.clone()
              let rightEdgeOffsetX = previousElementWidth / 2
              
              // Sprawdź szerokość następnego elementu, żeby rozróżnić S22 od S38/P22/P38
              const nextElementWidth = elementWidth || previousElementWidth
              const isNextS22 = Math.abs(nextElementWidth - 0.184) < 0.02 // S22 ma szerokość ~0.184
              const isNextS38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 's38' // S38 ma szerokość ~0.148
              const isNextP22 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p22' // P22 ma szerokość ~0.148 (taka sama jak S38)
              const isNextP38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p38' // P38 ma szerokość ~0.148 (taka sama jak S38/P22)
              const isPrevS22 = Math.abs(previousElementWidth - 0.184) < 0.02 // Poprzedni to S22
              
              console.log(`🔍 DEBUG S22 spacing: nextElementWidth=${nextElementWidth.toFixed(6)}, previousElementWidth=${previousElementWidth.toFixed(6)}, elementWidth=${elementWidth?.toFixed(6) || 'undefined'}, selectedVariant=${selectedVariant}, isNextS22=${isNextS22}, isNextS38=${isNextS38}, isNextP22=${isNextP22}, isNextP38=${isNextP38}, isPrevS22=${isPrevS22}, postSpacing=${postSpacing.toFixed(6)}`)
              
              // 🎯 W Muro Mix: jeśli poprzedni to S22 i następny też jest S22 (lub szerokość jest taka sama), użyj 0.3
              // Jeśli następny to P22, zmniejsz odstęp (0.1)
              // Jeśli następny to P38, zwiększ odstęp (dodaj spacing 0.1)
              // Jeśli następny to S38, dodaj spacing (0.1)
              if ((isPrevS22 && isNextS22) || Math.abs(nextElementWidth - previousElementWidth) < 0.01) {
                // S22 -> S22: użyj 0.3 (odejmij spacing)
                rightEdgeOffsetX -= postSpacing * 0.3
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> S22)`)
              } else if (isPrevS22 && isNextP22) {
                // S22 -> P22: użyj 0.1 (odejmij spacing, żeby lekko zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.1
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> P22)`)
              } else if (isPrevS22 && isNextP38) {
                // S22 -> P38: dodaj spacing (0.1), żeby zwiększyć odstęp
                rightEdgeOffsetX += postSpacing * 0.1
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> P38)`)
              } else if (isNextS38) {
                // S22 -> S38: dodaj spacing (0.1), żeby zwiększyć odstęp
                rightEdgeOffsetX += postSpacing * 0.1
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> S38)`)
              } else {
                // Domyślnie dla S22 -> S22: użyj 0.3 (jeśli poprzedni to S22)
                if (isPrevS22) {
                  rightEdgeOffsetX -= postSpacing * 0.3
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> S22, domyślne)`)
                } else {
                  rightEdgeOffsetX += postSpacing * 0.1
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S22 -> S38, domyślne)`)
                }
              }
              
              // Obróć offset zgodnie z rotacją posta
              const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
              rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              
              contactPoint = prevPos.clone().add(rightEdgeOffset)
              
              console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
              console.log(`  - previousElementWidth: ${previousElementWidth.toFixed(6)}`)
              console.log(`  - nextElementWidth: ${nextElementWidth.toFixed(6)}`)
              console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
              console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else if (isRotated && fenceType === 'S38') {
              // Dla zrotowanego S38: oblicz rightEdge bezpośrednio z pozycji posta
              // Rozróżnij S38 -> S38 (0.1) od S38 -> S22 (0.2) na podstawie szerokości następnego elementu
              // S38: spacing = 0.074, szerokość posta = 0.148
              // S22: spacing = 0.092, szerokość posta = 0.184
              const prevPos = previousElement.position.clone()
              let rightEdgeOffsetX = previousElementWidth / 2
              
              // Sprawdź szerokość następnego elementu, żeby rozróżnić S38 od S22/P22
              const nextElementWidth = elementWidth || previousElementWidth
              const isNextS38 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 's38' // S38 ma szerokość ~0.148
              const isNextP22 = Math.abs(nextElementWidth - 0.148) < 0.02 && selectedVariant === 'p22' // P22 ma szerokość ~0.148 (taka sama jak S38)
              const isNextS22 = Math.abs(nextElementWidth - 0.184) < 0.02 // S22 ma szerokość ~0.184
              const isPrevS38 = Math.abs(previousElementWidth - 0.148) < 0.02 // Poprzedni to S38
              
              console.log(`🔍 DEBUG S38 spacing: nextElementWidth=${nextElementWidth.toFixed(6)}, previousElementWidth=${previousElementWidth.toFixed(6)}, elementWidth=${elementWidth?.toFixed(6) || 'undefined'}, selectedVariant=${selectedVariant}, isNextS38=${isNextS38}, isNextP22=${isNextP22}, isNextS22=${isNextS22}, isPrevS38=${isPrevS38}, postSpacing=${postSpacing.toFixed(6)}`)
              
              // 🎯 W Muro Mix: najpierw sprawdź, czy następny to P22 (używając selectedVariant)
              // Potem sprawdź, czy następny to S38
              // Potem sprawdź, czy następny to S22
              if (isPrevS38 && isNextP22) {
                // S38 -> P22: użyj 0.3 (odejmij spacing, żeby zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.3
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S38 -> P22)`)
              } else if (isNextS38 && Math.abs(nextElementWidth - previousElementWidth) < 0.01) {
                // S38 -> S38: użyj 0 (bez kompensacji)
                rightEdgeOffsetX -= postSpacing * 0
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S38 -> S38)`)
              } else if (isNextS22) {
                // S38 -> S22: użyj 0.3 (odejmij spacing, żeby jeszcze bardziej zmniejszyć odstęp)
                rightEdgeOffsetX -= postSpacing * 0.3
                console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S38 -> S22)`)
              } else {
                // Domyślnie dla S38 -> S38: użyj 0 (bez kompensacji), jeśli szerokość jest taka sama
                if (Math.abs(nextElementWidth - previousElementWidth) < 0.01) {
                  rightEdgeOffsetX -= postSpacing * 0
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S38 -> S38, domyślne)`)
                } else {
                  rightEdgeOffsetX -= postSpacing * 0.3
                  console.log(`🎯 Muro Mix ${fenceType}: post -> post (ZROTOWANY ${previousRotation}°), obliczam rightEdge bezpośrednio z pozycji posta (S38 -> S22, domyślne)`)
                }
              }
              
              // Obróć offset zgodnie z rotacją posta
              const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
              rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              
              contactPoint = prevPos.clone().add(rightEdgeOffset)
              
              console.log(`  - prevPos: X=${prevPos.x.toFixed(6)}, Z=${prevPos.z.toFixed(6)}`)
              console.log(`  - previousElementWidth: ${previousElementWidth.toFixed(6)}`)
              console.log(`  - nextElementWidth: ${nextElementWidth.toFixed(6)}`)
              console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
              console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            } else {
              // Dla nie-zrotowanych postów lub innych typów: użyj rightEdge z userData (już ustawiony w contactPoint)
              console.log(`🎯 Muro Mix ${fenceType}: post -> post (${isRotated ? 'ZROTOWANY' : 'NIE-ZROTOWANY'}), używam rightEdge z userData`)
              console.log(`  - rightEdge z userData: X=${previousElement.userData.rightEdge.x.toFixed(6)}, Z=${previousElement.userData.rightEdge.z.toFixed(6)}`)
              console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
            }
          }
          
          // 🎯 Przypadek 4: post -> gate/door (oblicz rightEdge bezpośrednio, tak jak w isMuroP22PostToGateDoor)
          // Dla Muro Mix P38: użyj tej samej logiki co w isMuroP38PostToGateDoor (dodaj 10mm zamiast odejmować)
          if (previousElementType === 'post' && (nextElementType === 'gate' || nextElementType === 'door')) {
            // Definiuj fenceType dla przypadku 4 (post -> gate/door)
            const isMuroMixP22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p22'
            const isMuroMixP38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-p38'
            const isMuroMixS22ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s22'
            const isMuroMixS38ForSpacing = previousElement.userData?.originalFenceConfigId === 'lupane-muro-mix' && previousElement.userData?.fenceConfig?.id === 'lupane-muro-s38'
            let fenceType = 'P22'
            if (isMuroMixP22ForSpacing) fenceType = 'P22'
            else if (isMuroMixP38ForSpacing) fenceType = 'P38'
            else if (isMuroMixS22ForSpacing) fenceType = 'S22'
            else if (isMuroMixS38ForSpacing) fenceType = 'S38'
            
            // Oblicz rightEdge bezpośrednio z pozycji posta i jego szerokości
            // Post ma szerokość = spacing * 2 = 0.148, więc rightEdge = pozycja + (szerokość / 2) = pozycja + 0.074
            // Ale post nie ma odjętego spacing w swoim rightEdge, więc musimy odjąć spacing, żeby gate/door było w odpowiednim miejscu
            const prevPos = previousElement.position.clone()
            let rightEdgeOffsetX = previousElementWidth / 2
            
            // 🎯 Dla P38: dodaj spacing zamiast odejmować (P38 ma inną geometrię niż P22)
            // Dla P22/S22/S38: odejmij 2x spacing (jak w P22)
            if (fenceType === 'P38') {
              // Dla P38: dodaj 10mm (0.074m * 0.135 ≈ 10mm) zamiast odejmować (tak jak w isMuroP38PostToGateDoor)
              rightEdgeOffsetX -= postSpacing * -0.135
            } else {
              // Dla P22/S22/S38: odejmij 2x spacing (jak w P22)
              rightEdgeOffsetX -= postSpacing
              rightEdgeOffsetX -= postSpacing
            }
            
            const rightEdgeOffset = new THREE.Vector3(rightEdgeOffsetX, 0, 0)
            rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
            
            contactPoint = prevPos.clone().add(rightEdgeOffset)
            
            // 🚪 Dla gate/door w S22: ustaw odstęp po lewej
            // Sprawdź rotację posta - jeśli post jest zrotowany, następny element też będzie zrotowany
            const isRotated = Math.abs(previousRotationRad) > 0.01
            const previousAbsoluteRotation = previousElement.userData?.absoluteRotation || 0
            const isRotatedAbsolute = Math.abs(previousAbsoluteRotation) > 0.01
            const isNotRotated = !isRotated && !isRotatedAbsolute
            // Dla zrotowanych gate/door: sprawdź, czy następny element będzie zrotowany
            // W Muro Mix, jeśli post jest zrotowany, następny element też będzie zrotowany
            const willNextBeRotated = isRotated || isRotatedAbsolute
            
            console.log(`🔍 DEBUG Muro Mix S22/S38 gate/door left offset: fenceType=${fenceType}, isNotRotated=${isNotRotated}, isRotated=${isRotated}, isRotatedAbsolute=${isRotatedAbsolute}, willNextBeRotated=${willNextBeRotated}`)
            if (fenceType === 'S22') {
              const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
              const sectionSpacing = sectionConfig?.spacing || 0.086
              const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier || 1
              console.log(`🔍 DEBUG Muro Mix S22 gate/door: nextWidthMultiplier=${nextWidthMultiplier}, sectionSpacing=${sectionSpacing}, willNextBeRotated=${willNextBeRotated}`)
              // Dla 2x: zwiększ odstęp po lewej (tak samo dla zrotowanych i niezrotowanych)
              // Dla zrotowanych gate/door: dodatkowo zwiększ odstęp po lewej
              let leftOffsetMultiplier = -0.2
              if (nextWidthMultiplier === 2) {
                leftOffsetMultiplier = 1.4 // Dla 2x: offset po lewej
              }
              // Dla zrotowanych gate/door: dodatkowo zwiększ odstęp po lewej
              if (willNextBeRotated) {
                leftOffsetMultiplier += 0.3 // Dodatkowy offset dla zrotowanych
                console.log(`✅ Muro Mix S22: Dodaję dodatkowy offset 0.3 dla zrotowanych gate/door, leftOffsetMultiplier=${leftOffsetMultiplier}`)
              }
              const leftOffset = sectionSpacing * leftOffsetMultiplier
              const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
              leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              // Dla zrotowanych: używaj leftOffsetVector.z (prawidłowe przesunięcie po rotacji)
              // Dla niezrotowanych: zachowaj wartość Z
              contactPoint = new THREE.Vector3(
                contactPoint.x + leftOffsetVector.x,
                contactPoint.y + leftOffsetVector.y,
                isNotRotated ? contactPoint.z : contactPoint.z + leftOffsetVector.z
              )
              console.log(`✅ Muro Mix S22: post -> ${nextElementType} (${nextWidthMultiplier}x, ${isNotRotated ? 'niezrotowany' : 'zrotowany'}), ustawiono odstęp po lewej o ${leftOffset.toFixed(3)}m`)
              console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
              console.log(`  - contactPoint po ustawieniu odstępu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
              // Wyczyść __nextElementWidthMultiplier po użyciu
              ;(window as any).__nextElementWidthMultiplier = undefined
            } else if (fenceType === 'S38') {
              const sectionConfig = previousElement.userData?.fenceConfig?.elements?.section
              const sectionSpacing = sectionConfig?.spacing || 0.074
              const nextWidthMultiplier = (window as any).__nextElementWidthMultiplier || 1
              console.log(`🔍 DEBUG Muro Mix S38 gate/door: nextWidthMultiplier=${nextWidthMultiplier}, sectionSpacing=${sectionSpacing}, willNextBeRotated=${willNextBeRotated}`)
              // Dla 2x: zmniejsz odstęp po lewej (mniejszy niż dla S22)
              let leftOffsetMultiplier = -0.2
              if (nextWidthMultiplier === 2) {
                leftOffsetMultiplier = 1.9 // Dla 2x: offset po lewej
              }
              // Dla zrotowanych gate/door: dodatkowo zwiększ odstęp po lewej
              if (willNextBeRotated) {
                leftOffsetMultiplier += 0.3 // Dodatkowy offset dla zrotowanych
                console.log(`✅ Muro Mix S38: Dodaję dodatkowy offset 0.3 dla zrotowanych gate/door, leftOffsetMultiplier=${leftOffsetMultiplier}`)
              }
              const leftOffset = sectionSpacing * leftOffsetMultiplier
              const leftOffsetVector = new THREE.Vector3(-leftOffset, 0, 0)
              leftOffsetVector.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
              // Dla zrotowanych: używaj leftOffsetVector.z (prawidłowe przesunięcie po rotacji)
              // Dla niezrotowanych: zachowaj wartość Z
              contactPoint = new THREE.Vector3(
                contactPoint.x + leftOffsetVector.x,
                contactPoint.y + leftOffsetVector.y,
                isNotRotated ? contactPoint.z : contactPoint.z + leftOffsetVector.z
              )
              console.log(`✅ Muro Mix S38: post -> ${nextElementType} (${nextWidthMultiplier}x, ${isNotRotated ? 'niezrotowany' : 'zrotowany'}), ustawiono odstęp po lewej o ${leftOffset.toFixed(3)}m`)
              console.log(`  - leftOffsetVector: X=${leftOffsetVector.x.toFixed(6)}, Z=${leftOffsetVector.z.toFixed(6)}`)
              console.log(`  - contactPoint po ustawieniu odstępu: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
              // Wyczyść __nextElementWidthMultiplier po użyciu
              ;(window as any).__nextElementWidthMultiplier = undefined
            }
            
            console.log(`🎯 Muro Mix ${fenceType}: post -> ${nextElementType}, obliczam rightEdge bezpośrednio (bez zapisanego)`)
            console.log(`  - rightEdgeOffsetX (przed rotacją): ${rightEdgeOffsetX.toFixed(6)}`)
            console.log(`  - rightEdgeOffset (po rotacji): X=${rightEdgeOffset.x.toFixed(6)}, Z=${rightEdgeOffset.z.toFixed(6)}`)
            console.log(`  - contactPoint: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
          }
        }
        
        // 🎯 Przypadek 5: gate/door -> gate/door lub gate/door -> section (używamy rightEdge z userData, bez dodatkowych modyfikacji)
        // Ten przypadek jest już obsłużony przez użycie rightEdge z userData, więc nie trzeba nic dodawać
      }
      
      // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long i slim-3d: gdy dodajemy gate/door po post lub section, musimy uwzględnić kompensację
      // Post i section w vision-bet-long/max/medium/gladkie-max/gladkie-long/slim-3d mają kompensację w rightEdge (odejmowanie spacing i rightOffset)
      // Gate/door jest pozycjonowane na podstawie tego rightEdge, więc jego lewa krawędź jest w skompensowanym rightEdge
      // Musimy przesunąć contactPoint w prawo o wartość kompensacji, żeby gate/door nie nachodziło
      // Uwaga: elementWidth może wskazywać na gate/door (szerokość > 0.5m dla vision-bet-long/max/medium/gladkie-max/gladkie-long/slim-3d)
      const fenceConfigId = previousElement.userData?.fenceConfig?.id
      const previousElementTypeForCompensation = previousElement.userData?.originalElementType || previousElement.userData?.elementType
      const isVisionBetLong = fenceConfigId === 'vision-bet-long'
      const isVisionBetMax = fenceConfigId === 'vision-bet-max'
      const isVisionBetMedium = fenceConfigId === 'vision-bet-medium'
      const isGladkieMedium = fenceConfigId === 'gladkie_medium'
      const isGladkieMax = fenceConfigId === 'gladkie_max'
      const isGladkieLong = fenceConfigId === 'gladkie_long' || fenceConfigId === 'slim3d-kopia'
      const isSlim3d = fenceConfigId === 'slim-3d'
      const isSlim = fenceConfigId === 'slim'
      // 🎯 Slim-3D i Slim traktujemy jak zwykłe section – NIE stosuj specjalnej bramowej kompensacji
      // w tym bloku – oznacza to, że gate/door Slim zachowuje się identycznie jak section.
      const isVisionBet = isVisionBetLong || isVisionBetMax || isVisionBetMedium || isGladkieMedium || isGladkieMax || isGladkieLong
      const isPostOrSection = previousElementTypeForCompensation === 'post' || previousElementTypeForCompensation === 'section'
      // Dla vision-bet-long/max/medium/gladkie-max/gladkie-long/slim-3d, gate/door ma szerokość około 0.5-1.0m (widthFromDAE * widthMultiplier)
      // Post i section mają szerokość około 0.198m (spacing)
      // Jeśli elementWidth > 0.4m, prawdopodobnie to gate/door
      const isLikelyGateOrDoor = elementWidth > 0.4
      
      // 🚪 Dla vision-bet-long, vision-bet-max, vision-bet-medium, gladkie-max, gladkie-long i slim-3d gate/door: NIE dodawaj kompensacji, bo gate/door ma już prawidłowy rightEdge jak section
      // Gate/door w vision-bet-long/max/medium/gladkie-max/gladkie-long/slim-3d jest traktowane jak section, więc ma już kompensację w rightEdge
      // calculateNextElementPosition używa rightEdge poprzedniego elementu i dodaje halfWidth, co ustawia środek nowego elementu
      // Więc gate/door będzie pozycjonowane tak samo jak section - bez dodatkowej kompensacji
      if (isVisionBet && isPostOrSection && (isLikelyGateOrDoor || nextElementType === 'gate' || nextElementType === 'door')) {
        let fenceType = ''
        if (isVisionBetLong) fenceType = 'vision-bet-long'
        else if (isVisionBetMax) fenceType = 'vision-bet-max'
        else if (isVisionBetMedium) fenceType = 'vision-bet-medium'
        else if (isGladkieMedium) fenceType = 'gladkie_medium'
        else if (isGladkieMax) fenceType = 'gladkie_max'
        else if (isGladkieLong) fenceType = 'gladkie_long'
        else if (isSlim3d) fenceType = 'slim-3d'
        else if (isSlim) fenceType = 'slim'
        console.log(`🚪 ${fenceType}: nowy element=${nextElementType || (isLikelyGateOrDoor ? 'gate' : 'door')}, poprzedni=${previousElementTypeForCompensation}`)
        console.log(`🚪 ${fenceType}: gate/door jest traktowane jak section, więc NIE dodajemy kompensacji (rightEdge już ma kompensację)`)
        // NIE dodawaj kompensacji - gate/door ma już prawidłowy rightEdge jak section
      }
      
      // 🎯 Dla Royal S50 i Royal P50: gdy dodajemy section/gate/door po post, odejmij spacing post od rightEdge
      // Post w royal_s50/royal_p50 ma spacing 0.099, ale rightEdge nie ma odjętego spacing
      // Gdy dodajemy section/gate/door po post, musimy uwzględnić spacing post, żeby element był prawidłowo pozycjonowany
      // ⚠️ Dla Muro P22: ta logika jest już obsłużona w bloku isMuroP22PostToGateDoor (obliczanie bezpośrednie z pozycji posta)
      const isRoyalS50 = fenceConfigId === 'royal_s50'
      const isRoyalP50 = fenceConfigId === 'royal_p50'
      const isRoyal = isRoyalS50 || isRoyalP50
      if (isRoyal && previousElementTypeForCompensation === 'post' && (nextElementType === 'section' || nextElementType === 'gate' || nextElementType === 'door')) {
        const postConfig = previousElement.userData?.fenceConfig?.elements?.post
        const postSpacing = postConfig?.spacing || 0.099
        const fenceType = isRoyalS50 ? 'Royal S50' : 'Royal P50'
        
        if (nextElementType === 'gate') {
          // 🚪 Dla bramy: przesuń w lewo (ujemne przesunięcie), żeby zmniejszyć odstęp od lewej strony
          const additionalOffset = postSpacing * 2.0 // Przesuń w lewo o 2.0x spacing (zmniejszenie odstępu)
          const spacingOffset = new THREE.Vector3(-additionalOffset, 0, 0)
          spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(spacingOffset)
          console.log(`🚪 ${fenceType}: post -> gate, odjęto przesunięcie ${additionalOffset.toFixed(3)}m w lewo (zmniejszenie odstępu)`)
          console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu przesunięcia: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else if (nextElementType === 'door') {
          // 🚪 Dla furtki: mniejsze przesunięcie w lewo, żeby nie nachodziła na poprzedni element
          const additionalOffset = postSpacing * 0.5 // Przesuń w lewo o 0.5x spacing (mniejsze przesunięcie dla furtki)
          const spacingOffset = new THREE.Vector3(-additionalOffset, 0, 0)
          spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
          contactPoint.add(spacingOffset)
          console.log(`🚪 ${fenceType}: post -> door, odjęto przesunięcie ${additionalOffset.toFixed(3)}m w lewo (zmniejszenie odstępu dla furtki)`)
          console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
          console.log(`  - contactPoint po dodaniu przesunięcia: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        } else {
          // Dla section: odejmij pełny spacing
        const spacingOffset = new THREE.Vector3(-postSpacing, 0, 0)
        spacingOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
        contactPoint.add(spacingOffset)
        console.log(`🎯 ${fenceType}: post -> ${nextElementType}, odjęto spacing post ${postSpacing.toFixed(3)}m od rightEdge`)
        console.log(`  - spacingOffset: X=${spacingOffset.x.toFixed(6)}, Z=${spacingOffset.z.toFixed(6)}`)
        console.log(`  - contactPoint po odjęciu spacing: X=${contactPoint.x.toFixed(6)}, Z=${contactPoint.z.toFixed(6)}`)
        }
      }
    } else {
      // Fallback: oblicz prawą krawędź od środka (BEZ geometryOffsetZ!)
      console.log('  - obliczam rightEdge (fallback)')
      
      const prevPos = previousElement.position.clone()
      
      console.log('    - prevPos:', 'X:', prevPos.x.toFixed(6), 'Z:', prevPos.z.toFixed(6))
      
      // 🎯 Prawa krawędź od środka (zwykły offset, bez geometryOffsetZ)
      const rightEdgeOffset = new THREE.Vector3(previousElementWidth / 2, 0, 0)
      rightEdgeOffset.applyEuler(new THREE.Euler(0, previousRotationRad, 0))
      
      contactPoint = prevPos.clone().add(rightEdgeOffset)
      
      console.log('    - rightEdgeOffset:', 'X:', rightEdgeOffset.x.toFixed(6), 'Z:', rightEdgeOffset.z.toFixed(6))
    }
    
    console.log('  - contactPoint FINAL:', 'X:', contactPoint.x.toFixed(6), 'Z:', contactPoint.z.toFixed(6))
    
    // Kierunek dla nowego elementu
    const directionX = Math.cos(previousRotationRad)
    const directionZ = -Math.sin(previousRotationRad)
    
    console.log('  - direction:', 'X:', directionX.toFixed(6), 'Z:', directionZ.toFixed(6))

    // 🎯 Nowy element - ŚRODEK = contactPoint + kierunek * połowa szerokości
    const halfWidth = elementWidth / 2
    let newPositionY = previousElement.position.y
    
    // 🚪 Dla gate i door w royal_s50, royal_p50, muro p22, muro s22, muro p38 i muro s38: obniż do poziomu ziemi (Y=0)
    if ((nextElementType === 'gate' || nextElementType === 'door')) {
      // Sprawdź fenceConfig z poprzedniego elementu (dla tego samego ogrodzenia)
      const fenceConfigId = previousElement.userData?.fenceConfig?.id
      const originalFenceConfigId = previousElement.userData?.originalFenceConfigId
      const variant = previousElement.userData?.variant
      
      // Sprawdź czy to Muro Mix z wariantem S38
      const isMuroMixS38 = originalFenceConfigId === 'lupane-muro-mix' && variant === 's38'
      
      if (fenceConfigId === 'royal_s50' || fenceConfigId === 'royal_p50' || fenceConfigId === 'lupane-muro-p22' || fenceConfigId === 'lupane-muro-s22' || fenceConfigId === 'lupane-muro-p38' || fenceConfigId === 'lupane-muro-s38' || isMuroMixS38) {
        newPositionY = 0
        let fenceType = ''
        if (fenceConfigId === 'royal_s50') fenceType = 'Royal-S50'
        else if (fenceConfigId === 'royal_p50') fenceType = 'Royal-P50'
        else if (fenceConfigId === 'lupane-muro-p22') fenceType = 'Muro-P22'
        else if (fenceConfigId === 'lupane-muro-s22') fenceType = 'Muro-S22'
        else if (fenceConfigId === 'lupane-muro-p38') fenceType = 'Muro-P38'
        else if (fenceConfigId === 'lupane-muro-s38' || isMuroMixS38) fenceType = 'Muro-S38'
        console.log(`🚪 ${fenceType} ${nextElementType}: obniżono do poziomu ziemi (Y=0, było ${previousElement.position.y.toFixed(3)})`)
      }
    }
    
    const newCenterPosition = {
      x: contactPoint.x + (directionX * halfWidth),
      y: newPositionY,
      z: contactPoint.z + (directionZ * halfWidth)
    }
    
    console.log('  - halfWidth:', halfWidth)
    console.log('  - newCenterPosition:', 'X:', newCenterPosition.x.toFixed(6), 'Y:', newCenterPosition.y.toFixed(6), 'Z:', newCenterPosition.z.toFixed(6))
    console.log('🔍 calculateNextElementPosition END')

    return {
      ...newCenterPosition,
      rotation: previousAbsoluteRotation
    }
  }

  resetElementRotation(elementGroup: THREE.Group): void {
    elementGroup.rotation.y = 0

    if (elementGroup.userData) {
      elementGroup.userData.inheritedRotation = 0
      elementGroup.userData.rotation = 0
      elementGroup.userData.absoluteRotation = 0
      elementGroup.userData.reactRotation = 0
      // NIE usuwaj geometryOffsetZ!
    }
  }
}
